const TR = {
  '1': 'Ocak',
  '2': 'Şubat',
  '3': 'Mart',
  '4': 'Nisan',
  '5': 'Mayıs',
  '6': 'Haziran',
  '7': 'Temmuz',
  '8': 'Ağustos',
  '9': 'Eylül',
  '10': 'Ekim',
  '11': 'Kasım',
  '12': 'Aralık',
  'lucky.darw.ruls.1': 'Sohbet odalarından hediyeler gönderin, çekilişe katılma şansı yakalayın',
  'lucky.darw.ruls.2': 'Her 5000 coins hediye size 1 çekiliş hakkı verir',
  'lucky.darw.ruls.3': 'Örneğin: 50.000 coins = 10 çekiliş, 100.000 coins = 20 çekiliş. Daha fazla çekiliş için daha fazla hediye gönderin',
  'lucky.darw.ruls.4': 'Gün biterse ve çekilişlerinizi kullanmadıysanız, etkinlik bittikten sonra tüm çekilişleriniz 0 olur',
  'lucky.darw.number': 'çekilişlerimin sayısı',
  'lucky.darw.reset.time': 'SÜREYİ SIFIRLA',
  'lucky.darw.ranking': 'Çekiliş Sıralaması',
  'lucky.darw.use': 'KULLANMAYA GİT',
  'lucky.darw.no.times': 'Mevcut çekiliş sayısı yeterli değil, odaya gidin ve hediye gönderin',
  'lucky.darw.end': 'Etkinlik devam etmiyor',
  'lucky.darw.coin.one.times': '1 defa çekme masrafı',
  'lucky.darw.coin.draw': 'Çek',
  'lucky.darw.coin.more.times': 'defa masrafı',
  'lucky.darw.coin.more.will.cost': 'tutacak',
  'fission.coins': 'coins',
  'common.recharge.text': 'Yeterli Coins’iniz yok. Yükleme yapmak ister misiniz?',
  'fission.cancel': 'İptal',
  'lucky.darw.title': 'Şanslı Çekiliş',
  'gacha.play.3': 'defa',
  'gacha.play.1': 'aç',
  'gacha.play.2': 'defa',
  'common.cap.Congratulations': 'Tebrikler',
  'common.up.OK': 'Tamam',
  'recharge.result.pending': 'İşlem tamamlandı',
  'recharge.result.tips': 'Coinsler zamanında ulaşmazsa, lütfen endişelenmeyin, ağ gecikmeleri olabilir. Herhangi bir sorunuz varsa, lütfen Soyou resmi müşteri hizmetleri ile iletişime geçin.',
  'recharge.result.tips.click': 'APP\'ye dönmek için tıklayın',
  'coin.recharge.modal.title': 'Ödeme Yöntemi',
  'coin.recharge.change.country': 'Ülke Seçin',
  'coin.recharge.current.country': 'Şu anda kullandığınız ödeme kanalı:',
  'ajax.timeout': 'Üzgünüz, bir şeyler ters gitti. Lütfen daha sonra tekrar deneyin.',
  'ajax.system': 'Üzgünüz, bir şeyler ters gitti. Lütfen daha sonra tekrar deneyin.',
  'ajax.network': 'Ağ bağlantısı yok. Lütfen daha sonra tekrar deneyin.',
  'blank': '<p>İlgili içerik bulunamadı</p> <p>Lütfen diğer kanalları kontrol edin</p>',
  'pull.refresh.deactivate': 'Yenilemek için çekin',
  'pull.refresh.activate': 'Yenilemek için bırakın',
  'pull.refresh.release': 'Daha fazla yükleniyor',
  'push.refresh.activate': 'Daha fazla yükleniyor',
  'push.refresh.noMore': 'Daha fazla bilgi yok',
  'click.refresh': 'Yenilemek için tıklayın',
  'share.whatsapp.tip': 'WhatsApp telefonunuzda yüklü olmayabilir, yükleyin ve tekrar deneyin.',
  'share.ok': 'Tamam',
  'share.install': 'Şimdi Soundi Radio Uygulamasını Yükleyin',
  'share.download': 'İndir',
  'share.play': 'Soundi Radio\'da Dinle',
  'share.live': 'Canlı Yayın',
  'expection.oops': 'HATA...',
  'expection.homeBtn': 'Ana Sayfa',
  'ERR500.tips': 'Bir şeyler yanlış gitti. Geliştiriciler bu konuda bilgilendirildi ve sorunu düzeltecekler. Lütfen daha sonra tekrar deneyin. Teşekkür ederiz.',
  'err404.tips': 'Aranan haber mevcut değil. Lütfen diğer konuları kontrol edin. Sizi orada bekliyoruz!',
  'commonErr': '<p>Sistem meşgul,</p><p>lütfen daha sonra tekrar deneyin</p>',
  'loading': 'Yükleniyor...',
  'retry': 'Tekrar dene',
  'viewMore': 'Daha fazla görüntüle',
  'more': 'daha fazla',
  'month.select': 'Ay Seçin',
  'hot': 'Popüler',
  'all': 'Tümü',
  'month.select.day': 'Tarih Seçin',
  'coin.merchant.title': 'CoinSatıcısı',
  'coin.merchant.set.password': 'Ticaret şifrenizi belirleyin',
  'coin.merchant.confirm.again': 'İşlem şifresini tekrar onaylayın',
  'coin.merchant.enter.password': 'İşlem şifrenizi girin',
  'coin.merchant.enter.original.password': 'Orijinal şifreyi girin',
  'coin.merchant.enter.new.password': 'Yeni şifreyi girin',
  'coin.merchant.confirm.new.again': 'Yeni şifreyi tekrar onaylayın',
  'coin.merchant.change.password': 'Şifre Değiştir',
  'coin.merchant.history.title': 'İşlem Geçmişi',
  'coin.merchant.history': 'Geçmiş',
  'coin.merchant.user': 'Kullanıcı',
  'coin.merchant.data': 'Veri',
  'coin.merchant.transaction.times': 'İşlem Sayısı',
  'coin.merchant.monthly.current': 'Aylık Tutar - {%s}',
  'coin.merchant.monthly.last': 'Aylık Tutar - {%s}',
  'coin.merchant.chat': 'Sohbet',
  'coin.merchant.coins.num': 'Madeni Para Envanteri:',
  'coin.merchant.transfer.coins': 'Madeni Para Transferi',
  'coin.merchant.enter.user.id': 'Kullanıcı kimliğini girin',
  'coin.merchant.search': 'Sorgulama',
  'coin.merchant.not.found': 'Kullanıcı bulunamadı',
  'coin.merchant.enter.amount': 'Miktarı girin',
  'coin.merchant.tips': 'Kullanıcıya ek bir miktar transfer etmek üzeresiniz, lütfen adı ve madeni para miktarını tekrar onaylayın. Bu işlem geri alınamaz ve resmi olarak herhangi bir yanlış işlemden sorumlu değildir.',
  'coin.merchant.enter.transaction.password': 'İşlem şifresini girin',
  'common.cap.Confirm': 'Onayla',
  'coin.merchant.enter': 'Girin',
  'coin.merchant.to': 'Alıcı:',
  'coin.merchant.amount': 'Miktar:',
  'coin.merchant.id': 'Kimlik:',
  'coin.merchant.search.id': 'Kimlik Ara',
  'coin.merchant.recharge.summary': 'Yükleme',
  'coin.merchant.coin.sales': 'Coin Satışı',
  'coin.merchant.password.tips': 'Şifre en az 8 karakter olmalı ve büyük harf, küçük harf ve rakam içermelidir.',
  'coin.merchant.password.error': 'Yanlış Şifre. Lütfen tekrar deneyin.',
  'coin.merchant.success': 'Havale başarılı',
  'coin.merchant.list.title': 'Miktar seçin',
  'coin.merchant.list.desc': 'Bu kullanıcıya coins transferi, yüklemekle eşdeğerdir ve aynı zamanda VIP deneyimini artırır.',
  'coin.merchant.transfer': 'Transfer',
  'coin.merchant.recharge.title': 'CoinSatıcı\nŞarj',
  'coin.merchant.min.input': 'Minimum miktar 1000',
  'coin.merchant.der.channel': 'Ödeme Yöntemi:',
  'coin.merchant.der.channel.tips': 'Aşağıdaki yöntemlerle ödemeyi tamamlayamıyorsanız, lütfen resmi ekip WhatsApp hattıyla iletişime geçerek satın almayla ilgili bilgi alın:',
  'coin.merchant.der.channel.tips.link': 'kopyala',
  'coin.merchant.der.current.country': 'Şu anda kullanılan ödeme kanalı:',
  'coin.merchant.der.change.country': 'Ülke Seçin',
  'coin.merchant.der.modal.title': 'Ödeme Yöntemi',
  'common.cap.Recharge': 'Şarj',
  'coin.merchant.der.id': 'TalkTalk Kimliği',
  'coin.merchant.der.name': 'TalkTalk Takma Adınız:',
  'coin.merchant.der.error': '*Sonuç Bulunamadı',
  'coin.merchant.der.amount': 'Şarj Miktarı:',
  'coin.merchant.der.redeem': 'Kullanılabilir Puanlar:',
  'coin.merchant.der.fail': 'Şarj Başarısız oldu',
  'coin.merchant.der.fail.tips': 'Hesabınıza yükleme işlemi başarısız oldu, lütfen herhangi bir sorunuz varsa bize şu adresten ulaşın: TT_support@molelive.com',
  'coin.merchant.der.complete': 'Yükleme başarılı',
  'coin.merchant.der.complete.tips': '{number} coins {name} adlı hesabınıza başarıyla yüklendi! Daha fazla eğlence için giriş yapın!',
  'coin.merchant.der.another': 'Başka bir hesaba şarj yapın',
  'coin.merchant.der.more': 'Daha fazla yükleme yapın',
  'coin.merchant.der.problem': 'Sorunlarla mı karşılaşıyorsunuz?',
  'coin.merchant.der.bind.phone': 'Cep telefonu numarası bağlayın',
  'coin.merchant.der.sms.code': 'Doğrulama kodunu girin',
  'coin.merchant.der.sms.tips': 'Anormal bir etkinlik tespit edildi. Hesabınızın güvenliğini sağlamak için lütfen aşağıdaki doğrulama sürecini tamamlayın.',
  'coin.merchant.der.bind.phone.placeholder': 'Cep Telefonu Numarası',
  'coin.merchant.der.resend': 'Yeniden gönder',
  'common.cap.Continue': 'Devam et',
  'coin.merchant.der.code.tips': 'Eğer doğrulama kodunu alamıyorsanız, lütfen resmi ekibin WhatsApp hattıyla iletişime geçin: [WhatsApp numarası]',
  'total.rank.gift': 'WEEKLY<br />STAR',
  'total.rank.hour': 'Saatlik',
  'total.rank.day': 'Gün',
  'total.rank.week': 'Haftalık',
  'total.rank.month': 'Aylık',
  'total.rank.last.hour': 'Son Saat İLK 3',
  'total.rank.last.day': 'Son Gün İLK 3',
  'total.rank.last.week': 'Son Hafta İLK 3',
  'total.rank.last.month': 'Son Ay İLK 3',
  'total.rank.this.hour': 'Bu Saat',
  'total.rank.this.day': 'Bu Gün',
  'total.rank.this.week': 'Bu Hafta',
  'total.rank.this.month': 'Bu Ay',
  'total.rank.gap': 'Gap{X}',
  'total.rank.hide': 'Sıralamada Gizle',
  'total.rank.hide.name': 'Bay Gizemli',
  'total.rank.hide.info': 'Gizli Bilgiler',
  'total.rank.help.title': 'Sıralama Kuralları',
  'total.rank.help': '<h1>Sıralama Türü</h1>\n<p>Sıralama &lt;Oda&gt;: Belirli bir zaman dilimi boyunca, tüm odalar, oda içinde gönderilen coins hediyelerine göre sıralanır.</p>\n<p>Sıralama &lt;HEDİYECİ&gt;: Belirli bir zaman dilimi boyunca, tüm kullanıcılar, kullanıcı tarafından gönderilen coins hediyelerine göre sıralanır.</p>\n<p>Sıralama &lt;BÜYÜLEYİCİ&gt;: Belirli bir zaman dilimi boyunca, tüm kullanıcılar, sizin aldığınız coins hediyelerine göre sıralanır.</p>\n\n<h1>Sıralama Zaman Döngüsü</h1>\n<p>Sıralama döngüsü genellikle saatler, günler, haftalar ve aylar olarak belirlenir.</p>\n<p>Sıralama, önceki döngünün en üst 3 sıralamasını ve güncel döngünün en üst 50 sıralamasını gerçek zamanlı olarak gösterir. (1 dakikadan az bir gecikme ile)</p>\n<p>Yenileme Zamanı (UTC+3): Günlük sıralama her gün saat 5\'te yenilenir; Haftalık sıralama her Pazartesi saat 5\'te yenilenir; Aylık sıralama her ayın 1. günü saat 5\'te yenilenir.</p>\n\n<h1>Gizlilik Koruma</h1>\n<p>Bazı sıralamalarda belirli rakamlar gösterilmez;</p>\n<p>Ancak, önceki sıralama ile arasındaki fark gösterilir;</p>\n<p>En üst 3 sıralama arasındaki fark gösterilmez.</p>',
  'total.rank.cp.help.title': 'CP Sıralama Kuralları',
  'total.rank.cp.help': '<h1>CP Sıralama Kuralları</h1>\n<p>CP Sıralama Listesi, en popüler ve en uzun süren harika CP\'leri gerçek zamanlı olarak gösterir. Listeye girerek tüm platformda görünürlük kazanın ve tatlılığınızı herkesin görmesini sağlayın!</p>\n<h1>Yakınlık Sıralama Listesi</h1>\n<p>Sıralama Kuralı: Dönem boyunca kazanılan yeni yakınlığa göre en yüksekten en düşüğe sıralanır. Sadece ilk 50 gösterilir.</p>\n<p>Katılım Koşulu: Son 7 gün içinde yakınlık artışı olan CP\'ler sadece listeye girebilir.</p>\n<h1>En Uzun Süreli CP Sıralama Listesi</h1>\n<p>Katılım Koşulu: Son 7 gün içinde yakınlık artışı olan geçerli CP çiftleri.</p>\n<p>Sıralama Kuralları:<br/>1. Önce ilişki süresine göre en uzun süreden en kısaya sıralanır<br/>2. Süre aynıysa, mevcut toplam yakınlığa göre en yüksekten en düşüğe sıralanır</p>\n<h1>Tüm Sıralama Listelerinden Otomatik Kaldırma</h1>\n<p>Aşağıdaki durumlarda otomatik olarak kaldırılacaksınız:<br/>● CP ilişkisi sonlandırıldı<br/>● 7 gün boyunca sürekli yakınlık artışı yok</p>\n<p>İhlal Politikası<br/>Haksız yollarla yakınlık kazanmak için hile yapan CP çiftlerinin sıralama durumu hemen iptal edilecek ve ilgili sahte yakınlık puanları düşülecektir.</p>',
  'total.rank.help.eu': '<h1>Sıralama Türü</h1>\n<p>Sıralama &lt;Oda&gt;: Belirli bir zaman dilimi boyunca, tüm odalar, oda içinde gönderilen coins hediyelerine göre sıralanır.</p>\n<p>Sıralama &lt;HEDİYECİ&gt;: Belirli bir zaman dilimi boyunca, tüm kullanıcılar, kullanıcı tarafından gönderilen coins hediyelerine göre sıralanır.</p>\n<p>Sıralama &lt;BÜYÜLEYİCİ&gt;: Belirli bir zaman dilimi boyunca, tüm kullanıcılar, sizin aldığınız coins hediyelerine göre sıralanır.</p>\n\n<h1>Sıralama Zaman Döngüsü</h1>\n<p>Sıralama döngüsü genellikle saatler, günler, haftalar ve aylar olarak belirlenir.</p>\n<p>Sıralama, önceki döngünün en üst 3 sıralamasını ve güncel döngünün en üst 50 sıralamasını gerçek zamanlı olarak gösterir. (1 dakikadan az bir gecikme ile)</p>\n<p>Yenileme Zamanı (UTC+3): Günlük sıralama her gün saat 5\'te yenilenir; Haftalık sıralama her Pazartesi saat 5\'te yenilenir; Aylık sıralama her ayın 1. günü saat 5\'te yenilenir.</p>\n\n<h1>Gizlilik Koruma</h1>\n<p>Bazı sıralamalarda belirli rakamlar gösterilmez;</p>\n<p>Ancak, önceki sıralama ile arasındaki fark gösterilir;</p>\n<p>En üst 3 sıralama arasındaki fark gösterilmez.</p>',
  'common.cap.Ranking': 'Sıralama',
  'total.rank.room': 'ODA',
  'total.rank.sent': 'HEDİYECİ',
  'common.up.RECEIVED': 'BÜYÜLEYİCİ',
  'fission.relation.by.amount': 'Miktarına Göre',
  'fission.relation.by.time': 'Zamana Göre',
  'common.cap.Countdown': 'Geri Sayım',
  'common.up.RULES': 'KURALLAR',
  'common.up.DAYS': 'GÜNLER',
  'common.up.HOURS': 'SAATLER',
  'common.up.MINS': 'DAKİKALAR',
  'common.cap.Successfully.Collected': 'Başarıyla Toplandı',
  'common.cap.Countdown.to.Start': 'Başlamaya Geri Sayım',
  'common.cap.Day': 'Gün',
  'common.cap.Hour': 'Saat',
  'common.cap.Min': 'Dakika',
  'common.cap.Sec': 'Saniye',
  'common.cap.Rules': 'Kurallar',
  'common.cap.event.over': 'Etkinlik sona erdi',
  'recharge.event.tab.1': 'Şarj İlerlemesi',
  'recharge.event.amount.reached': 'Miktarı ulaşılan madeni paralar',
  'recharge.event.ranking.list': 'Sıralama Listesi',
  'recharge.event.group': 'Grup',
  'recharge.event.next.1': 'Sadece şu kadar madeni para gerekiyor',
  'recharge.event.next.2': 'Sonraki seviyeye ulaşmak için',
  'recharge.event.rewards.for': 'Ödüller',
  'recharge.event.trouble': 'Şarjda sorun mu yaşıyorsunuz?',
  'recharge.event.done': 'Tebrikler! En yüksek seviyeye ulaştınız! Şimdi ödüllerinizi alın!',
  'fission.trouble': 'Şarjda sorun mu yaşıyorsunuz?',
  'common.cap.No': 'Hayır',
  'common.cap.Unfortunately.Yes': 'Maalesef Evet',
  'common.cap.Waiting': 'Bekliyor',
  'common.cap.update': 'Yeni özellikleri kullanmak için sürümü güncelleyin',
  'common.cap.Customer.Server': 'Müşteri Hizmetleri',
  'common.cap.Ranking.click': 'Tıklamak',
  'common.cap.Ranking.click.text': 'Farklı ödülleri kontrol etmek için tıklayın',
  'common.cap.Collect': 'Topla',
  'common.cap.Collected': 'Toplandı',
  'common.cap.Limited.Gifts': 'Sınırlı Hediyeler',
  'family.football.target': 'Coins Ödül Hedefi',
  'dream.city.rule.reward': 'Kurallar ve Ödüller',
  'dream.city.city.map': 'Şehir Haritası',
  'dream.city.rules': 'Etkinlik Kuralları',
  'dream.city.supply.reward': 'Destek İstasyonu Ödülleri',
  'dream.city.wealth': 'Zenginlik',
  'dream.city.charm': 'Çekicilik',
  'dream.city.wealth.rank': 'Zenginlik',
  'dream.city.charm.rank': 'Çekicilik',
  'dream.city.current.coins': 'Güncel Coinsler',
  'dream.city.current.diamonds': 'Güncel Elmaslar',
  'dream.city.go': 'BAŞLA',
  'dream.city.will.get': 'Alacaksınız',
  'dream.city.received': 'Tebrikler! Aldınız',
  'dream.city.top5': 'En hızlı şekilde destek istasyonuna ulaşan ilk 5 kullanıcı, destek ödüllerini alacak.',
  'dream.city.waiting': 'bekliyor',
  'about.title': 'Hakkında',
  'Terms of Service': 'Kullanım Koşulları',
  'Privacy Policy': 'Gizlilik Politikası',
  'Return Policy': 'İade Politikası',
  'Intellectual Property Rights': 'Fikri Mülkiyet Hakları',
  'Contact Us': 'İletişim',
  'About Us': 'Hakkımızda',
  'Supported Payment Methods': 'Desteklenen Ödeme Yöntemleri',
  'subTitle': 'Onaylanmış Tüccarlar Dışında Diğer Şarj Kanallarına Güvenmeyin.',
  'chat': 'Sohbet',
  'id': 'Soyou Kimliği',
  'contact': 'İletişim',
  'whatsapp': 'WhatsApp',
  'right': 'Soyou ekibi en nihai yorum hakkını saklı tutar.',
  'check': 'Şifre en az 8 haneli ve büyük/küçük harfler içermelidir.',
  'same': 'Lütfen aynı şifreyi girin',
  'copied': 'kopyalandı',
  'order.record.title': 'Kayıt',
  'order.record.failed': 'Yükleme Başarısız',
  'order.record.recharging': 'Yükleniyor',
  'order.record.succeeded': 'Yükleme Başarılı',
  'order.record.order.id': 'Sipariş no: {id}',
  'order.record.channel': 'Kanal: {name}',
  'details': 'Elmas Detayları',
  'miss': 'Kaçırılan Elmaslar',
  'profit': 'Gelir İstatistikleri',
  'missToday': 'Kaçırılan-Bugün',
  'cumulativeMiss': 'Kaçırılan-Toplam',
  'distributionOfDiamondIncome': 'Elmas gelir dağılımı',
  'getDiamondsMonth': 'Bu ayki elmaslar:',
  'getDiamondsDay': 'Bugünkü elmaslar:',
  'cancel': 'İptal',
  'confirm': 'Onayla',
  'daily': 'Günlük',
  'month': 'Ay',
  'tips': 'Daha fazla veri yok',
  'voiceChat': 'Ankelle Sesli Sohbet için Kullanıcı Değerlendirmeleri',
  'voiceChat1': 'Benimle Sesli Sohbet için Kullanıcı Değerlendirmeleri',
  'quickCall': 'Ankelle Hızlı Arama için Kullanıcı Değerlendirmeleri',
  'quickCall1': 'Benimle Hızlı Arama için Kullanıcı Değerlendirmeleri',
  'chatting': 'Mesaj sohbet performansı',
  'chatting1': 'Benim sohbet performansım',
  'chatSpeed': 'Cevap hızı',
  'chatSpeed1': 'Mesajlara cevap verme hızım',
  'like': 'Beğen',
  'boring': 'Sıkıcı',
  'Hate': 'Nefret',
  'chatConversation': '💬 Sohbet Turu',
  'reached': '🙋‍♀️ Kullanıcı sayısı',
  'count': '🙋‍♀️ Mesajlar',
  'speed': 'Cevap hızı',
  'quality': 'Sohbet kalitesi',
  'call': 'Arama ve Değerlendirme',
  'currentCycle': 'Güncel Döngü',
  'speedTitle': 'Mesaja Cevap Verme Gelir Kuralları',
  'roundTitle': 'Sohbet Turu Gelir Kuralları',
  'modalTips': 'Mesajlara daha hızlı cevap vermeniz, kullanıcı deneyimini iyileştirecek ve daha fazla elmas kazanmanıza yardımcı olacaktır.',
  'modalTipsTwo': 'Cevap içeriğinizin daha yüksek kalitesi ve daha fazla sohbet turu, kullanıcı deneyimini iyileştirecek ve daha fazla elmas kazanmanıza yardımcı olacaktır.',
  'modalTipsThree': 'Yanıtlarınızın kalitesi ne kadar yüksek olursa o kadar fazla elmas kazanırsınız. Ek ödüllerin günlük limiti {%s}',
  'modalSpeed': 'Yanıt hızı',
  'modalIncome': 'Gelir Oranı',
  'modalRound': 'Sohbet turları',
  'modalReward': 'Ekstra ödüller',
  'modalBtn': 'Sohbete Devam Et',
  'cycleDiamonds': 'Bu döngüdeki elmaslar',
  'terms.help': 'Uygulama Sorunları',
  'terms.bug': 'Hata',
  'terms.suggestions': 'Öneriler',
  'contacts.whatsapp': 'Whatsapp',
  'contacts.email': 'E-posta',
  'contacts.phone': 'Telefon',
  'submit.success': 'Geri bildiriminiz için teşekkür ederiz',
  'terms.title': 'Kategori',
  'details.placeholder': 'Lütfen sorununuzun detaylarını açıklayın',
  'contacts.title': 'Sizi nasıl iletişime geçebiliriz',
  'contact.placeholder': 'İletişim bilgilerinizi buraya bırakın [Gizli]',
  'submit.btn': 'Gönder',
  'country.select.hot': 'Popüler',
  'country.select.all': 'Tümü',
  'feedback.details': 'Detaylar',
  'feedback.screenshot': 'Ekran Görüntüsü (İsteğe Bağlı)',
  'feedback.title': 'Geri Bildirim',
  'flowWater': 'Madeni Para Detayları',
  'coinBack': 'İade Edilen Madeni Paralar',
  'home.recharge': 'Şarj',
  'home.slogan': 'Burada ruh eşinizi bulun<br />Her zaman yanınızda',
  'home.download': 'İndir',
  'income.rules.rules.1': '1. Maaş Kuralları: Her ayın 16\'sı ve takip eden ayın 1\'i 00:00\'da hesaptaki elmas bakiyesinden kesilecektir.',
  'income.rules.rules.2': '2. Maaş Oranı: 1USD=0 elmas',
  'income.rules.rules.3': '3. Hesap Dönemi: ①Her ayın 16\'sı 00:00② takip eden ayın 1\'i 00:00',
  'income.rules.rules.4': '4. Hesap Dönemi: 7~14 iş günü (tatiller ertelenebilir)',
  'income.rules.chat': 'Müşteri Hizmetleri ile İletişim',
  'income.rules.important': 'Vurgu:',
  'income.rules.title': 'Maaş Kuralları',
  'income.rules.rules.extra': 'Maaş ödendiğinde \"Soyou Takımı\" tarafından size bildirim yapılacaktır. Elmas kesinti ayrıntıları \"Gelir\" bölümünde kontrol edilebilir, lütfen Soyou Takımı bildirimlerine dikkat edin. Normal hesap dönemi genellikle 7-14 iş günü içinde tamamlanır, tatil günleri banka işlem süresini geciktirebilir, lütfen sabırlı olun ve ödemenizi bekleyin. Herhangi bir sorunuz varsa, lütfen Soyou Müşteri Hizmetleri ile iletişime geçin, desteğiniz için teşekkür ederiz!',
  'income.rules.usd': 'USD',
  'income.rules.diamonds': 'Elmaslar',
  'my.earning.title': 'Kazançlarım',
  'my.earning.tips': 'Elmas bakiyesi',
  'my.earning.daimonds': 'elmaslar',
  'my.earning.withdrawal.rules': 'Çekim Kuralları',
  'my.earning.salary.rules': 'Maaş Kuralları',
  'new.task.go': 'Git',
  'new.task.done': 'Tamamlandı',
  'task.center.title': 'Görev Merkezi',
  'recharge.result.success': 'Ödeme Başarılı',
  'recharge.result.error': 'Ödeme Başarısız',
  'report.option.Porn': 'Pornografi',
  'report.option.Spam': 'Spam',
  'report.option.Fraud': 'Dolandırıcılık',
  'report.option.Violence': 'Şiddet',
  'report.option.Illegal': 'Yasa dışı',
  'report.option.Other': 'Diğer',
  'report.option.room': 'Bunu beğenmedim',
  'report.option.user': 'Kullanıcıyı beğenmedim',
  'report.reason': 'Kategori',
  'report.details': 'Detaylar',
  'report.details.placeholder': 'Raporunuzu ayrıntılı olarak açıklayın',
  'report.screenshot': 'Ekran Görüntüsü (İsteğe Bağlı)',
  'report.submit': 'Gönder',
  'report.submit.success': 'Başarıyla rapor edildi',
  'report.room': 'Rapor',
  'report.user': 'Kullanıcıyı Rapor Et',
  'retirar.rules.title': 'Çekim Kuralları',
  'retirar.rules.rules.1': '1. Çekim hizmetini kullanmadan önce, hesabınızın güvenliğini sağlamak için gerçek kimlik bilgilerinizi göndermeniz gerekmektedir.',
  'retirar.rules.rules.2': '2. Lütfen gerçek kimlik bilgileri sağlayın, bu bilgiler Soyou hesabınızın tanımlanması ve kullanma hakkının belirlenmesi için kullanılacaktır.',
  'retirar.rules.rules.3': '3. Gönderdiğiniz kimlik bilgileri kesinlikle gizli tutulacak ve diğer amaçlarla kullanılmayacaktır.',
  'retirar.rules.chat': 'Müşteri Hizmetleri ile İletişim',
  'retirar.rules.important': 'Vurgu:',
  'retirar.rules.rules.extra': 'Çekim hizmetini kullanmak için lütfen müşteri hizmetleriyle iletişime geçin ve aşağıdaki bilgileri sağlayın:',
  'retirar.rules.rules.extra.1': '1) Gerçek ad',
  'retirar.rules.rules.extra.2': '2) Whatsapp numarası',
  'retirar.rules.rules.extra.3': '3) Kimlik belgeleri (kimlik kartları, pasaportlar vb.)',
  'retirar.rules.rules.extra.4': '4) Ödeme yönteminiz (Banka Transferi, Payoneer, Fawry vb.)',
  'task.center.retirar': 'Şimdi Talep Et',
  'task.center.complete': 'Tamamlandı',
  'total.rank.daily': 'Günlük',
  'task.center.common.level': 'Seviye',
  'common.cap.Event.To.Start': 'Etkinlik Başlamak Üzere',
  'task.center.limit.task': 'Limited Task',
  'task.center.normal.task': 'Normal Task',
  'task.center.limit.today': 'Today',
  'task.center.limit.Total': 'Total',
  'task.center.limit.Diamonds.Received': 'Diamonds Received',
  'task.center.limit.Reward.Received': 'Reward Received',
  'task.center.limit.receive': 'Receive',
  'task.center.limit.extra': 'Extra',
  'task.center.limit.to.start': 'Event has not started yet',
  'gift.wall.title': 'Hediyeler',
  'gift.wall.help.text1': 'Bir seferde {num} coins\'i aşan hediyeler, hediye duvarında görünecektir',
  'gift.wall.help.text2': 'Daha fazla coins\'e sahip olan hediye ilk sıralamada gösterilecektir.',
  'gift.wall.help.text3': 'Hediye duvarındaki kayıt 24 saat boyunca saklanacaktır.',
  'level.user': 'Kullanıcı\nSeviyesi',
  'level.halo': 'Halo\nSeviyesi',
  'level.halo.question1.title': 'Yüksek Seviyenin Faydaları',
  'level.halo.question1.answer1': 'Daha Yüksek seviye , Daha Parlak Halo',
  'level.halo.question2.title': 'Seviye Simge Görüntüsü',
  'level.halo.question2.answer1': 'Seviye ne kadar yüksekse, simge o kadar benzersizdir',
  'level.halo.question3.title': 'Seviye Yükselme Ödülleri',
  'level.halo.question3.answer1': 'Harika Ödüller Almak İçin Seviye Atlayın',
  'level.halo.question4.title': 'Seviye Yükselmenin Yolları',
  'level.halo.question4.answer1': '1 coin değerinde hediye alın, 1 deneyim puanı kazanın.\nDeneyim ne kadar yüksekse, yükseltme o kadar hızlı olur.',
  'level.user.question1.title': 'Yüksek Seviye Faydaları',
  'level.user.question1.answer1': 'Özel eşyalar ve ödüller alırsınız.',
  'level.user.question2.title': 'Seviye Atlamanın Yolları',
  'level.user.question2.answer1': 'Odada sohbet edin, oyun oynayın ve hediyeler gönderin',
  'level.user.question2.answer2': 'Günlük görevleri tamamlayın, seviye atlamak için deneyim kazanın',
  'level.user.question2.answer7': 'Odanızda Parti Yapın',
  'level.user.question2.answer8': 'Coins\'le hediyeler yollayın',
  'level.user.question2.answer9': 'Görevleri tamamlayın ve Deneyim Puanı toplayın',
  'level.user.question3.title': 'Seviye Simge Görüntüsü',
  'level.user.question3.answer1': 'Seviye ne kadar yüksekse, simge o kadar benzersizdir.',
  'level.user.question4.title': 'Seviye Atlama Ödülleri',
  'level.user.question4.answer1': 'Harika Ödüller Almak İçin Seviye Atlayın',
  'level.user.level': 'Seviye',
  'level.user.icon': 'Simge',
  'level.user.tips': 'Deneyim puanları kazanmaya devam ettikçe seviyeniz kademeli olarak artacaktır.',
  'level.user.way.up': 'Deneyim puanlarını artırmanın yolları:',
  'about.badges.title': 'Rozetler',
  'about.badges.0': 'Rozetleri Giymek',
  'about.badges.1': 'Tüm rozetler takılabilir, aynı anda 5 adet rozet takabilirsiniz..',
  'about.badges.2': 'Onur Rozeti',
  'about.badges.3': 'Kümülatif aylık değerlere göre kilidi açılan rozetler, sahip olunsun veya olunmasın her ayın 1\'inde sayılır. Geçerlilik süresi bir ay sürer.',
  'vip.privileges.title.privacy': 'Gizlilik ve Güvenlik',
  'vip.privileges.label.privacy': 'Diğerleri seni/senin odanı arayamaz',
  'vip.privileges.title.invisible': 'Görünmez Mod',
  'vip.privileges.label.invisible': 'Görünmez kalın ve kendinizi başkaların tavsiyelerinden gizleyin',
  'vip.privileges.title.blockMessages': 'Sessiz Mod',
  'vip.privileges.label.blockMessages': 'Yabancıların mesajlarını engelle ve rahatsız edilme',
  'vip.privileges.title': 'VIP Ayrıcalıkları',
  'vip.privileges.activate': 'VIP{N} Etkinleştir',
  'vip.privileges.stealth.text': 'Erişim geçmişimi gizle',
  'vip.privileges.stealth.open': 'Aç',
  'vip.privileges.stealth.close': 'Kapat',
  'vip.privileges.title.icon': 'VIP etiketi',
  'vip.privileges.label.icon': 'Mükemmel vip etiketi, özel vip kullanıcı statüsü, itibarınızı göstermek için sizinle her yerde',
  'vip.privileges.title.visitor': 'Ziyaretçi Geçmişi',
  'vip.privileges.label.visitor': 'Tüm ziyaretçi geçmişini görün, sizinle ilgili kişileri ve hayranları kaçırmazsınız',
  'vip.privileges.title.list': 'Öncelikli görüntüleme',
  'vip.privileges.label.list': 'En iyi arama sonuçlarında öncelikli görüntüleme',
  'vip.privileges.title.follower': 'Takipleri yükselt',
  'vip.privileges.label.follower': 'Daha fazla arkadaş takip edebilirsiniz: VIP olmayan biri 500 kişiyi takip edebilir, vip1 1000 kişiyi takip edebilir, vip4 2000 kişiyi takip edebilir, vip7 3000 kişiyi takip edebilir',
  'vip.privileges.title.sign': 'VIP giriş hediyesi',
  'vip.privileges.label.sign': 'VIP\'ler, oturum açma hediyelerinden iki kat yararlanabilir',
  'vip.privileges.title.stealth': 'Görünmez erişim',
  'vip.privileges.label.stealth': 'Diğer kullanıcıları ziyaret ettiğinizde geçmiş kaydedilmez',
  'vip.privileges.title.name': 'Kullanıcı adı vurgusu',
  'vip.privileges.label.name': 'Kullanıcılar, kullanıcı adını süslemek için özel efektler alır',
  'vip.privileges.title.avatar': 'VIP profil çerçevesi',
  'vip.privileges.label.avatar': 'Özel vip avatarı',
  'vip.privileges.title.bubble': 'VIP özel sohbet balonu',
  'vip.privileges.label.bubble': 'Özel vip sohbet balonları',
  'vip.privileges.title.room': 'VIP oda kartı',
  'vip.privileges.label.room': 'Özel vip oda kartı',
  'vip.privileges.title.picture': 'Resimlerle sohbet et',
  'vip.privileges.label.picture': 'bubble sohbette resim gönderme seçeneği',
  'vip.privileges.title.message': 'Mesajları üste sabitle',
  'vip.privileges.label.message': 'Diğer kullanıcıların sohbetini mesajın üstüne sabitleme imkanı',
  'vip.privileges.title.vehicle': 'ViP Araçlar',
  'vip.privileges.label.vehicle': 'Özel VIP araçlar',
  'vip.privileges.title.rank': 'Sıralamada Gizem',
  'vip.privileges.label.rank': 'Sıralamalarda Gizemli olarak görünmek için görünmezlik anahtarını açabilirsiniz',
  'vip.privileges.title.broadcast': 'Platform genelinde gönderilen yükseltme bildirimi',
  'vip.privileges.label.broadcast': 'Vip8 veya üstüne ulaştığınızda yükseltme bildirimleri platform genelinde gönderilebilir',
  'vip.privileges.title.id': 'Benzersiz kişisel kimlik',
  'vip.privileges.label.id': 'Benzersiz kişisel kimliğinizi alın ve başkalarının sizi bir bakışta hatırlamasına izin verin! Benzersiz numaranızı almak için VIP müşteri hizmetlerinize başvurmanız gerekir. Sayı formatı (vip8: 6 haneli ABABAB. vip9: 6 haneli AAABBB; vip10: 4 haneli ABAB; vip11: 4 haneli ABAB. (vip11:4 haneli AABB). Bıraktıktan sonra geri çağır.',
  'vip.privileges.title.protection': 'VIP Koruması',
  'vip.privileges.label.protection': 'Sohbetten yasaklanma ve odalardan çıkarılma konusunda asla endişelenmeyin',
  'vip.privileges.title.gif': 'Özel GIF profil çerçevesi',
  'vip.privileges.label.gif': 'Farkınızı göstermek için kendi özel GIF profil çerçevenizi özelleştirin! VIP9\'a ulaştığınızda, özel GIF profil çerçevenizi almak için VIP müşteri hizmetleri ile iletişime geçmeniz gerekecektir. kullanıcı başına yalnızca bir kez kullanılabilir.',
  'vip.privileges.title.gift': 'Kişiye Özel Hediyeler',
  'vip.privileges.label.gift': 'Seçtiğiniz kişi için özel hediyenizi özelleştirin!\nVIP10\'e ulaştığınızda, kişiye özel bir hediye almak için VIP müşteri hizmetleri ile iletişime geçmeniz gerekir, her kullanıcının yalnızca bir kişiselleştirme şansı vardır.',
  'vip.privileges.title.exclusivevehicles': 'Özel araçlar',
  'vip.privileges.label.exclusivevehicles': 'Özel araçlarınızı benzersiz giriş efektleriyle özelleştirin! VIP11\'e ulaştığınızda.\nKullanıcı başına yalnızca bir kez kullanılabilen özel araçlara sahip olmak için VIP müşteri hizmetleri ile iletişime geçmeniz gerekir.',
  'vip.privileges.title.open': 'Özel açılış sayfası',
  'vip.privileges.label.open': 'Uygulamayı açın ve tüm ihtişamınızla siz olun! VIP12\'ye ulaştığınızda, her kullanıcı için yalnızca bir kez kullanılabilen 24 saat özel kişiselleştirilmiş açılış sayfası almak için VIP müşteri hizmetlerinizle iletişime geçmeniz gerekir.',
  'vip.privileges.update.info': 'Vip sistemi güncellendi, sürümünüz en son özellikleri görüntülemek için çok düşük. Lütfen en son sürüme güncelleyin ve yeni vip işlevinin keyfini çıkarın!',
  'aristocracy.vip.title': 'Aristokrasi',
  'vip.help.1': 'VIP Kuralları',
  'vip.help.2': 'VIP nedir',
  'vip.help.3': 'VIP, Soyou\'ta özel bir durumun somutlaştırılmış halidir. VIP sahibi olduktan sonra ilgili onur ve avantajları alabileceğiniz 11 statü seviyesi içerir',
  'vip.help.4': 'Vip seviyesi nasıl yükseltilir',
  'vip.help.5': 'Kullanıcılar, her 1 $\'lık yeniden yükleme için 1 VIP deneyimi alacaktır.</br>\nKullanıcılar, birikmiş VIP deneyim puanları o aydaki yükseltme deneyim puanına ulaştığında VIP seviyelerini hemen yükselteceklerdir.</br>\nVIP olduktan sonraki her ayın ilk gününde, kullanıcının bir önceki aya ait birikmiş deneyimi silinecektir.\nVe kullanıcının VIP seviyesi, kullanıcının bir önceki ay birikmiş deneyimine göre yeniden düzenlenecektir.',
  'vip.help.6': 'VIP seviyesi yükseltme kuralları',
  'vip.help.7': 'Yükseltme kuralları',
  'vip.help.8': 'Bu ay için yükseltme kriterlerine ulaştığınızda, VIP seviyeniz hemen güncellenecek ve VIP seviyeniz bir sonraki ayın sonuna kadar korunacaktır. Örneğin, bir kullanıcı 5 Haziran\'da VIP4\'e ulaşırsa, VIP4\'ü 31 Temmuz\'a kadar sürer',
  'vip.help.9': 'VIP Dondurma Kuralları',
  'vip.help.10': 'Birikmiş exp değeriniz bu ay mevcut VIP seviyeniz için gerekli exp değerine ulaşırsa, bir sonraki ay VIP seviyenizi koruyacaksınız; aksi takdirde VIP seviyeniz bir sonraki ay düşürülecektir. Örneğin: Mayıs\'ta VIP5 iseniz, ancak Mayıs\'ta yalnızca VIP3 exp değeri biriktirdiyseniz, VIP seviyeniz Haziran\'ın ilk günü VIP3\'e düşürülecektir',
  'vip.help.11': 'VIP seviyesi indirimi',
  'vip.help.12': 'Her ayın 1\'inde, her ayın ilk günü sıfırlanmadan önce VIP düzeyine göre mevcut kullanıcının VIP düzeyi exp değerine göre belirli bir miktar VIP iade edilir',
  'vip.help.13': 'Seviye',
  'vip.help.14': 'Exp değeri aralığı',
  'vip.help.15': 'Experience of exp',
  'vip.help.update.info': 'Vip sistemi güncellendi, sürümünüz en son özellikleri görüntülemek için çok düşük. Lütfen en son sürüme güncelleyin ve yeni vip işlevinin keyfini çıkarın!',
  'to.exchange.page.button': 'Değişim',
  'ranking.daily': 'Günlük',
  'ranking.weekly': 'Haftalık',
  'ranking.contributed': 'Katkıda bulundu:',
  'ranking.blank.daily': 'Bugün kimse hediye göndermedi',
  'ranking.blank.weekly': 'Bu hafta kimse hediye göndermedi',
  'lucky.packet.title': 'Şanslı Paket',
  'lucky.packet.1': 'Şanslı Paket Gönder',
  'lucky.packet.2': 'Odadaki tüm kullanıcılar şanslı paket gönderebilir ve talep edebilir',
  'lucky.packet.3': 'Bir odada çok sayıda şanslı paket olduğunda, bunlar saklanacaktır ve görüntülenecektir. Şanslı paketler ne kadar erken gönderilirse, üstte o kadar çok gösterilir.',
  'lucky.packet.4': 'Kısıtlamalar ve Koşullar',
  'lucky.packet.5': 'Yalnızca Coins destekler',
  'lucky.packet.6': '2. Kişi Aralığı: 3~500.',
  'lucky.packet.7': '3. Kişi başına miktar (altın miktarı/kişi sayısı) en az 1 altın olmalıdır.',
  'lucky.packet.8': 'Paket miktarı 10000 coins\'ten fazla olduğunda ve katılımcı sayısı 10\'den fazla olduğunda, bu bir uçan bildirimi tetikleyecek ve oda listesinde özel bir simge görüntülenecektir.',
  'lucky.packet.9': 'Nasıl Oynanır',
  'lucky.packet.10': '\"Password\"Lucky packet - Almak için şifreyi odaya göndermeniz gerekiyor.',
  'lucky.packet.11': '\"Follow\"Lucky packet -Almak için şanslı paketi gönderen kullanıcıyı takip etmeniz gerekir.',
  'lucky.packet.12': 'Genel Problem',
  'lucky.packet.13': 'Paket uçuş bildirimini tetiklediğinde veya şanslı paket simgesi görüntülendiğinde, diğer kullanıcılar buna tıklayarak odanıza girebilir',
  'lucky.packet.14': 'Eğer odanız kilitliyse, bu uçan bildirimi veya diğer harici görüntü efektlerini tetiklemez',
  'efficient_text_2': 'Etkili zaman',
  'efficient_text_5': 'Etkili gün',
  'efficient_text_6': '1. Odada geçerli zaman',
  'efficient_text_7': 'Ses odasında, mikrofondaki zaman - mikrofondan çıkma süresi> = %$ dakika mikrofon üzerinde etkili bir zamandır. Mikrofondaki kişiyi uzun süre iyi arkadaşlarla sohbet etme ve etkileşim kurma inisiyatifine katılmaya teşvik ediyoruz, örneğin:',
  'efficient_text_8': 'Mikrofonda Zaman',
  'efficient_text_9': 'Mikrofon kapalı zaman',
  'efficient_text_10': 'Standarda ulaşıp ulaşmadığı',
  'efficient_text_11': 'Açıklama',
  'efficient_text_12': 'Standarda ulaşır',
  'efficient_text_13': 'Standarda ulaşmadı',
  'efficient_text_14': 'Mikrofondaki zaman ertesi güne kadar sürerse, bir önceki günün zamanı olarak sayılır',
  'efficient_text_15': 'Mikrofonun kalması -Mikrofon <%$ dakika.',
  'efficient_text_16': 'Mikrofondaki mikrofon zamanının süresi> = %$ dakika',
  'efficient_text_17': '12/1 9:00:00 Mikrofonda zaman standarda ulaşmadı, etkili bir süre olarak sayılamaz',
  'efficient_text_18': '12/1 23:00:00 Mikrofonda 12/2 kadar devam etti ve arka arkaya 90 dakika sürdü, bu yüzden 12/1 sırasında zaman olarak sayılır',
  'efficient_text_19': '2. Odanın etkili günleri',
  'efficient_text_20': 'Ses odasında, tüm etkili süreler gün boyunca eklenir> = %$ dakika etkili bir gündür. Geçerli gün sayısı ne kadar yüksek olursa, faaliyet o kadar yüksek olur ve aktivite oranı, elde ettiğiniz ödülleri doğrudan etkiler.',
  'efficient_text_21': 'Toplam Etkili Süre',
  'efficient_text_22': 'Gün boyunca mikrofonda 12/1 3 kez: 15 dakika +35 dakika +90 dakika. 15 dakika standardı karşılamadığından, geçerli zaman = 90 +35 = 125 dakika = 02h 05 dakika',
  'efficient_text_23': '12/1 Toplamda Günün Geçerli Süresi = 02h 05min> = %$ dakika, geçerli bir gün olarak sayılır',
  'efficient_text_24': '3. Mikrofonda zaman',
  'efficient_text_25': 'Mikrofondaki zaman etkili bir zaman olmalı ve etkili zaman> = %$ dakika olmalıdır. Mikrofondaki zaman yalnızca odadaki mikrofonda sohbet etme süresini gösterir. Mikrofondaki zaman> = %$ dakika gibi etkili bir zaman olarak kabul edilecektir, örneğin:',
  'efficient_text_26': '4. Veri Ayrıntıları',
  'efficient_text_27': 'Veriler seçilen döngüye göre görüntülenecektir',
  'efficient_text_28': 'Elmas',
  'efficient_text_29': 'Sohbet',
  'efficient_text_30': 'Ses Odası',
  'efficient_text_31': 'Detaylar',
  'efficient_text_32': 'Tarih',
  'efficient_text_33': 'Mikrofonda Zaman',
  'efficient_text_34': 'Ses odasının etkili zamanı',
  'efficient_text_35': 'Ses odasının etkili günleri',
  'share_text23': 'indirmek',
  'share_text24': 'Odaya Katılın',
  'share_text25': 'Bu odadayım, gel ve bize katıl',
  'share_text26': 'Oda kimliği',
  'OfficialTask_Card_common_text1': 'Resmi görev',
  'OfficialTask_Card_common_text2': 'Resmi ödül görevini tamamladıktan sonra maksimum {%s} elmas alabilirsiniz!',
  'OfficialTask_dailyCard_text1': 'Günlük elmas geliri ödülleri ({%s1}/{%s2})',
  'OfficialTask_dailyCard_text2': 'Günlük elmas geliri ({%s1}) {%s2} 💎\'ye ulaştı, {%s3} 💎 alın',
  'OfficialTask_dailyCard_text3': 'Günlük elmas geliri ödülleri ({%s3}) {%s1} 💎\'ye ulaştı, {%s2} 💎 kazanın',
  'OfficialTask_dailyCard_text4': 'Ödül Zamanı',
  'OfficialTask_dailyCard_text5': 'İLERİ',
  'OfficialTask_PeriodCard_text1': 'Çalışma Dönemi Elmas Ödülü ({%s1}/{%s2})',
  'OfficialTask_PeriodCard_text2': 'Çalışma dönemi elmas ödülü ({%s3}) {%s1} 💎\'ye ulaştı, {%s2} alın 💎',
  'OfficialTask_ActiveCard_text1': 'Çalışma dönemi aktif ödülü',
  'OfficialTask_ActiveCard_text2': '{%s1} tian ({%s2}/{%s3}) döngüsünde kümülatif giriş',
  'OfficialTask_ActiveCard_text3': 'Günlük elmas geliri {%s1} 💎\'ye ulaşırsa, {%s2} 💎 alabilirsiniz. (Bugün: {%s3}/{%s4})',
  'OfficialTaskPic_Level_text1': 'Günlük Elmas Geliri Ödülleri (IM Mesajı)',
  'OfficialTaskPic_Level_text2': 'seviye',
  'OfficialTaskPic_Level_text3': 'Elmas Hedefi',
  'OfficialTaskPic_Level_text4': 'Elmas ödülü',
  'OfficialTaskPic_Level_text5': 'Günlük Elmas Gelir Ödülleri (Ses odası hediyeleri: normal ses odası + aile ses odası)',
  'OfficialTaskPic_Level_text6': 'Çalışma Dönemi Elmas Gelir Ödülleri (IM mesajı + alınan tüm hediyeler)',
  'OfficialTaskPic_Level_text7': 'Çalışma Dönemi Aktif Ödüller',
  'OfficialTaskPic_Level_text8': '{%s1} gün boyunca giriş yapın ve her gün {%s2} elmas kazanın',
  'OfficialTaskPic_Level_text9': 'Gereklilik',
  'OfficialTaskPic_Level_text10': 'Elmas ödülü',
  'OfficialTaskPic_Level_text11': 'Bildirim:',
  'OfficialTaskPic_Level_text12': '1. Ses odası hediyesi: normal ses odası ve aile ses odası dahil;',
  'OfficialTaskPic_Level_text13': '2. Çalışma dönemi aktif ödülü: Dönem bittikten sonra aktif günlerin sayısı sayılacak ve alabileceğiniz maksimum ödül 350 elmastır;',
  'OfficialTaskPic_Level_text14': '3. Tüm elmas ödülleri bu çalışma döneminde doğrudan hesabınıza gönderilecektir;',
  'OfficialTaskPic_Level_text15': '4. Her 80 elmas = 1 USD',
  'OfficialTaskPic_Level_text16': 'Günlük ödül (sohbetlerdeki hediyeler, sesli ve görüntülü aramalar, sesli eşleşme için)',
  'OfficialTaskPic_Level_text17': 'Sohbetler, ses ve video görüşmeleri, ses eşleştirme ve günlük hedefe ulaşma hediyeleri için elmas alırsanız, ilgili elmas ödülünü alırsınız. Ertesi gün otomatik olarak elmas ödüller eklenecektir.',
  'OfficialTaskPic_Level_text18': 'Günlük Ödül (sohbetler ve ses odalarındaki hediyeler için)',
  'OfficialTaskPic_Level_text19': 'Çalışma Dönemi Ödülü (ses ve video görüşmeleri için)',
  'OfficialTaskPic_Level_text20': '1. Sohbetlerde ve ses odalarında hediyeler için elmas alırsanız ve günlük hedefi karşılıyorsanız, ilgili elmas ödülünü alırsınız. Ertesi gün otomatik olarak elmas ödüller eklenecektir.',
  'OfficialTaskPic_Level_text21': '2. Ses ve video görüşmeleri için elmas alırsanız ve çalışma döneminin sonuna kadar hedefi karşılıyorsanız, ilgili elmas ödülünü alırsınız. Elmas ödülleri, çalışma döneminin bitiminden sonraki gün otomatik olarak eklenecektir.',
  'OfficialTaskPic_Level_text22': '3. Her ayın 1. ila 15\'inden 15\'e ve her ayın 16. ila 30./31\'leri arasında süren 2 çalışma süresi vardır.',
  'OfficialTaskPic_Level_text23': 'Günlük Ödül 1 (Sesli Parti Odası ve Aile Hediyesi Elmas)',
  'OfficialTaskPic_Level_text24': 'Günlük Ödül 2 (sesli çağrı, sesli eşleşme elmas)',
  'OfficialTaskPic_Level_text25': 'Çalışma Dönemi Ödülü (Sohbet, Sesli Parti Odası, Sesli Aramalar, Sesli Eşleştirme)',
  'OfficialTaskPic_Level_text26': '1. Sohbetlerde, sesli oda ve görüntülü aramalarda, sesli eşleşmede hediyeler karşılığında elmas alırsanız ve haftalık hedefi karşılarsanız, ilgili elmas ödülünü alacaksınız. Elmas ödülleri size eklenecek',
  'OfficialTaskPic_Level_text27': '2. Maaş oranı: 80 elmas = 1 USD',
  'OfficialTaskPic_Level_text28': '3. Günlük ödüllerden elde edilen elmaslar bu elmas hedefine dahil edilmeyecektir;',
  'OfficialTaskPic_Level_text29': 'Soyou Resmi Ödül Sistemi 02.2024',
  'OfficialTaskPic_Level_text30': 'Günlük Görev 1: Tüm Aramalar + Tüm Hediyeler',
  'OfficialTaskPic_Level_text31': 'Günlük Görev 2: Mesaj Cevabı',
  'OfficialTaskPic_Level_text32': 'Günlük Elmas Hedefi',
  'OfficialTaskPic_Level_text33': 'Günlük elmas hedefimiz yukarıda gösterilmiştir ve ödül sistemimizdeki bir gün Türk yerel saatine dayanmaktadır.',
  'cms_report_text3': 'Rapor Nedeni:',
  'cms_report_text4': 'Rapor Ayrıntıları:',
  'cms_report_text5': 'Rapor Ekran görüntüsü:',
  'cms_report_text6': '*Lütfen yukarıdaki bilgileri doğrulayın, böylece bilgi cezası uygulayabiliriz.',
  'cms_report_text7': 'Reporter Showid:',
  'cms_report_text8': 'The Reporter Showid:',
  'cms_report_text9': 'Ceza yöntemi:',
  'cms_report_text10': 'Ceza sonucu:',
  'cms_report_text11': 'Ceza geçmişi',
  'cms_report_text12': 'Sözlü uyarı',
  'cms_report_text13': 'Yasaklama yöntemi:',
  'cms_report_text14': 'Yasaklama nedenleri:',
  'cms_report_text15': 'Yasaklanma süresi:',
  'cms_report_text16': 'Siyasi hassasiyet',
  'cms_report_text17': 'Hakaret',
  'cms_report_text18': 'Saldırı ve Kötüye Kullanım',
  'cms_report_text19': 'Kanlı şiddet',
  'cms_report_text20': 'Reklam',
  'cms_report_text21': 'Şüpheli Dolandırıcılık',
  'cms_report_text22': 'Yasadışı bilgi',
  'cms_report_text23': 'Küçük',
  'cms_report_text24': 'diğer',
  'cms_report_text25': 'Onayla',
  'cms_report_text26': 'Hesaba duyarlı işlem, lütfen bilgilerden sonra bilgileri onaylayın.',
  'OfficialTask_dailyCard_text6': 'tamamlandı',
  'OfficialTask_rewardTime_text1': 'saat',
  'OfficialTask_rewardTime_text2': 'dakikalar',
  'delete_account_web_title': 'Sevgili Soyou kullanıcısı. Ürünümüzü kullandığınız ve desteklediğiniz için teşekkürler. Hesabınızı silmek isterseniz, lütfen işlem için aşağıdaki adımları kontrol edin:',
  'delete_account_web1': '1. Uygulamayı açın ve ana sayfayı girin, bana girmek için sağ altta tıklayın.',
  'delete_account_web2': '2. Bana girdikten sonra ayarları tıklayın.',
  'delete_account_web3': '3. Ayarları girdikten sonra Hesabı Sil\'i tıklayın.',
  'delete_account_web4': '4. Hesabı kalıcı olarak silmek için ilk adımı onaylayın.',
  'delete_account_web5': '5. İkinci adımı onaylayın için aynı hesabı kullanamaz.',
  'delete_account_web6': '6. İlgili tüm kişisel bilgileri silmek için son adımı onaylayın.',
  'delete_account_web7': '7. Yukarıdaki tüm adımları bitirdikten sonra. Hesabınız, tüm kişisel bilgileriniz ve hesap verilerinizle başarıyla silinmiştir. Platformumuz artık verilerinizi veritabanımızda tutmayacak.',
  'delete_account_web': 'Hesabı Sil',
  'svip_introduce_1': '1.SVIP nedir',
  'svip_introduce_text1': 'SVIP platformun seçkin seviye sistemidir. Toplamda 8 seviye vardır, SVIP1-SVIP8. Seviye ne kadar yüksek olursa, statü de o kadar seçkin olur ve sahip olduğunuz haklar ve çıkarlar da o kadar gelişmiş olur.',
  'svip_introduce_2': '2. Nasıl SVIP olunur?',
  'svip_introduce_text2': 'Coins yükleyerek SVIP deneyim puanı kazanabilirsiniz, 1 coins = 1 deneyim puanı. Deneyim puanları farklı SVIP seviyelerine ulaştığında, ilgili SVIP seviyesini elde edebilirsiniz.',
  'svip_introduce_3': '3. SVIP\'in geçerlilik süresi nasıl hesaplanır?',
  'svip_introduce_text31': 'SVIP her olağan ayı bir döngü olarak ele alır ve her ayın 1\'inde SVIP deneyim puanları 0\'dan toplanır. İlgili SVIP düzeyi, SVIP deneyim değerinin ulaştığı seviyeye göre elde edilecektir.',
  'svip_introduce_text32': 'SVIP statüsünü aldığınız andan itibaren statünüz ve ayrıcalıklarınız bir sonraki ayın sonuna kadar korunacaktır. (Örneğin: 18 Mayıs\'ta SVIP3\'e ulaşılırsa SVIP3 durumu 30 Haziran\'a kadar uzatılacaktır.)',
  'svip_introduce_text33': 'SVIP deneyim değeriniz bir ay içinde daha yüksek bir seviyeye ulaşırsa hemen yükseltilecektir. (Örneğin: 18 Mayıs\'ta SVIP3\'e ve 25 Mayıs\'ta SVIP4\'e ulaşırsanız, 25 Mayıs\'ta hemen SVIP4 statüsüne kavuşursunuz ve 30 Haziran sonuna kadar devam edersiniz.)',
  'svip_introduce_text34': 'Ay sona erdiğinde kimlik ve ayrıcalıklar korunacak ancak bir sonraki aya ait SVIP deneyim puanları 0\'dan toplanacaktır. (Örneğin: 25 Mayıs\'ta SVIP4\'e ulaşırsanız, kimlik ve haklardan yararlanmaya devam edeceksiniz.) Haziran ayı boyunca SVIP4, ancak Haziran ayında 0\'dan itibaren SVIP deneyim puanları biriktirmeye başlayacaksınız)',
  'svip_introduce_4': '4.SVIP\'in düşmesi ve puanların düşmesi',
  'svip_introduce_text41': 'Her ayın başında, SVIP seviyeniz varsa ve bu SVIP seviyenizi bir sonraki ayda da korumak istiyorsanız, doğal ayın sonundan önce SVIP seviyesi deneyim değerinin %50\'sine ulaşmanız gerekir; Önümüzdeki ay bu seviyeyi koruyabilir, kimliğini ve haklarını koruyabilir. (Örneğin: Mayıs başladığında SVIP4 olursunuz, o zaman SVIP4 seviyesini Haziran sonuna kadar korumak için Mayıs ayı boyunca SVIP4 seviyesinin deneyim değerinin %50\'sine ulaşmanız yeterlidir.)',
  'svip_introduce_text42': 'Olağan bir ay içinde SVIP seviyesi deneyim değerinin %50\'sine ulaşılamazsa, bir sonraki ayda 1 seviye düşürülecektir. (Örneğin: Mayıs ayının başında SVIP4\'sünüz ve Mayıs ayının tamamındaki deneyim değeriniz SVIP4 seviyesinin %50\'sine ulaşmıyorsa, Haziran ayı SVIP3\'ten başlayarak 1 seviye düşecektir.)',
  'noble_introduce_title': 'Aristokrasi Kurallarına Giriş',
  'noble_introduce_welcome': 'Aristokratik sistemimize hoş geldiniz! Aristokrat olmak, daha fazla benzersiz ayrıcalık ve avantajlardan yararlanmanıza olanak tanıyacaktır. Aşağıdakiler aristokratik sistemimize faydalı bir giriş niteliğindedir:',
  'noble_introduce_1': '1.Aristokrasi Nedir?',
  'noble_introduce_text1': 'Aristokrasi özel bir statü sembolüdür ve Şövalye, Baron, Vikont, Kont, Marki, Dük ve Kral olmak üzere yedi statü seviyesine bölünmüştür. Farklı aristokrasi düzeyleri farklı ayrıcalıklara sahiptir.',
  'noble_introduce_2': '2. Nasıl Aristokrat Olunur?',
  'noble_introduce_text2': 'Aristokrasi, coins yüklenerek satın alınabilir ve satın alma işlemi, Aristokrasi sayfasında ilgili seviye seçilerek tamamlanabilir. Aynı zamanda başkalarından alacağınız hediyelerle de Aristokrat statüsü elde edebilirsiniz.',
  'noble_introduce_3': '3. Geçerlilik Süresi Hesaplaması',
  'noble_introduce_text3': 'Aristokrat statüsü, satın alma tarihinden itibaren 30 gün süreyle geçerlidir ve geçerlilik süresi boyunca Aristokrat ayrıcalıklarından yararlanabilirsiniz. Ayrıcalıklar geçerlilik süresi sonunda sona erecektir.',
  'noble_introduce_4': '4. Günlük Coins Talimatları',
  'noble_introduce_text4': 'Aristokrasiyi coins ile satın aldıktan sonra, her gün hediye olarak coins almaya hak kazanırsınız. Her gün giriş yaptıktan sonra coins alabilirsiniz. Eğer o gün giriş yapmazsanız o günkü coinsleri alamayacaksınız. Aristokrasiyi başkalarına hediye ettiğinizde, alıcı günlük coins alma hakkını kazanacaktır.',
  'noble_introduce_5': '5. Sürekli Yükleme İndirimleri',
  'noble_introduce_text5': 'Aristokrat statünün kazanıldığı dönemde ve Aristokrat statünün sona ermesinden sonraki 10 gün içerisinde aynı Aristokrat statü daha uygun bir fiyata tekrar satın alınabilir. Bu plan otomatik değildir ve yürürlüğe girmesi için manuel olarak satın almanız gerekir.',
  'noble_introduce_6': '6. Aristokrasi Yükseltme',
  'noble_introduce_text6': 'Zaten Aristokrat statünüz varsa, daha yüksek seviye Aristokrasi satın alabilir ve denk gelen avantajlardan doğrudan yararlanabilirsiniz. Mevcut aristokrasinin kalan günleri, kalan değere göre en son seviyeye birleştirilecek ve yeni Aristokratik seviyenin geçerlilik süresi uzatılacak.',
  'noble_introduce_7': '7. Aristokrasi Hediye Etmek',
  'noble_introduce_text7': 'Aristokrasiyi başka bir kişiye hediye ederken, orijinal fiyattan kişiye verilecek ve alıcı, günlük coinslerden ve seviyeye karşılık gelen diğer haklardan yararlanacaktır. Alıcının zaten Aristokrat statüsü varsa, doğrudan yüksek seviyeli Aristokrat statüsünden yararlanacak ve diğer seviyeler ilgili süreye göre dönüştürülecektir.',
  'vip_introduce_title': 'VIP Kurallarına Giriş',
  'vip_introduce_welcome': 'VIP sistemimize hoş geldiniz! VIP daha fazla ayrıcalıktan yararlanmanızı sağlayacaktır. Aşağıda VIP sistemini açıklayıcı bir tanıtım yer almaktadır:',
  'vip_introduce_1': '1. VIP nedir?',
  'vip_introduce_text1': 'VIP bir kullanıcı gelişim sistemidir. Şu anda VIP1-VIP16 olmak üzere 16 seviye bulunmaktadır. VIP seviyesi ne kadar yüksek olursa, o kadar çok haktan yararlanırsınız ve işlevler de o kadar çeşitli olur.',
  'vip_introduce_2': '2.Nasıl VIP olunur?',
  'vip_introduce_text2': 'Coins yükleyerek VIP deneyim puanı kazanabilirsiniz, 1 coins = 1 deneyim puanı. Ne kadar çok coins yüklerseniz, o kadar çok deneyim puanı kazanırsınız ve VIP daha yüksek bir seviyeye yükselir.',
  'vip_introduce_3': '3.VIP Geçerlilik Süresi',
  'vip_introduce_text3': 'VIP statüsü alındıktan sonra kalıcı olarak geçerli olur ve VIP deneyim puanları kalıcı olarak birikir ve silinmez. Deneyim puanları arttıkça daha yüksek bir VIP seviyesine yükselecek ve daha fazla seviye avantajından yararlanacaksınız.',
  'vip_introduce_4': '4. VIP Aksesuar Kullanımı',
  'vip_introduce_text4': 'Elde ettiğiniz VIP seviyesi aksesuarları her zaman sırt çantanızda sabit kalacak ve istediğiniz zaman kullanılabilecektir. Yükseltme yaptığınızda, önceden elde ettiğiniz düşük seviyeli aksesuarlar yine kullanılabilir.',
  'svip_introduce_title': 'SVIP Kurallarına Giriş',
  'svip_introduce_welcome': 'SVIP sistemimize hoş geldiniz! VIP daha fazla ayrıcalıktan yararlanmanızı sağlayacaktır. Aşağıda SVIP sistemini açıklayıcı bir tanıtım yer almaktadır:',
  'svip_introduce_text43': 'Olağan bir ay içinde SVIP deneyim puanı oluşturulmazsa, SVIP seviyesi bir sonraki ay 3 seviye düşecektir. (Örneğin: Mayıs başladığında SVIP4 olursunuz ve Mayıs boyunca hiçbir deneyim puanı oluşturulmaz, ardından Haziran SVIP1\'den başlayarak 3 seviye düşecektir)',
  'svip_introduce_5': '5. SVIP\'in Hakları ve Faydaları',
  'svip_introduce_text5': 'SVIP seviyesi ne kadar yüksek olursa, o kadar fazla haktan yararlanırsınız. Seviyeniz değiştiğinde, yeni seviyenin avantajlarından yararlanıp o seviyeye denk gelen aksesuar ödüllerini alabileceksiniz. Kişiselleştirilmiş aksesuarlar yükseltilirken veya kullanımdayken aktif olarak müşteri hizmetleriyle iletişime geçmeniz ve kişiselleştirme gereksinimlerini dağıtılmadan önce belirtmeniz gerekir. Ancak, seviyeniz düşerse verilmeyecektir.',
  'svip_table1': 'SVIP Seviyesi',
  'vip_table1': 'VIP Seviyesi',
  'svip_table2': 'Ücretsiz Mesaj',
  'svip_table3': 'Ücretsiz Aramalar',
  'Anonymity_name': 'Anonim',
  'Noble_Change_2': 'Satın Alma Koşulları: Daha düşük rütbeler daha yüksek rütbeleri satın alabilir, ancak daha yüksek rütbeler daha düşük rütbeleri satın alamaz. Örneğin, halihazırda bir Kont iseniz yalnızca Marki, Dük veya Kral\'ı satın alabilirsiniz.',
  'Noble_Change_3': 'Dönüşüm Mantığı: Eğer zaten bir aristokrat iseniz, başka bir aristokrat rütbesi satın aldıktan sonra, eski aristokrat rütbesinin kalan geçerlilik süresi, coins fiyat oranına göre yeni aristokrat rütbesine dönüştürülecek ve eski aristokrat rütbesi geçersiz hale gelecektir.',
  'Noble_Change_4': 'Geçerlilik Dönemi Hesaplama Formülü: Yeni satın alınan aristokrat rütbenin geçerlilik süresi = mevcut aristokrat rütbenin kalan gün sayısı * (mevcut aristokrat rütbe fiyatı / satın alınan aristokrat rütbe fiyatı) + 30, son gün sayısı aşağı yuvarlanır.',
  'Noble_Change_5': 'Örnek: Şu anda bir Vikont iseniz (99990 coins/ay), 13 gününüz kaldı ve bugün Kont (199990 coins/ay) satın aldıysanız, ödeme yapıldıktan sonra Kont\'un geçerlilik süresi 13 * (99990/199990) olacaktır. + 30 = 6,5 aşağı yuvarlanmış + 30 = 36 gün.',
  'rich_list': 'Zenginlik Sıralaması',
  'lucky_list': 'Şans Sıralaması',
  'lucky_daily': 'Günlük',
  'lucky_weekly': 'Haftalık',
  'lucky_faq1': 'Nasıl Oynanır',
  'lucky_faq2': 'Oyun Kuralları',
  'lucky_faq3': '1. Şanslı bir hediye verdikten sonra 1-1000 katı kadar coins ödülü kazanma şansınız olur;',
  'lucky_faq4': '2. Kombo veya Toplu olarak ne kadar çok şanslı hediye gönderirseniz, kazanma şansınız o kadar artar;',
  'lucky_faq5': '3. Coins ödülleri hesap bakiyesine gerçek zamanlı olarak dağıtılacak ve kazanma ayrıntıları şanslı hediye kaydında görüntülenebilecek;',
  'lucky_faq6': '4. Her şanslı hediye verildiğinde, Yayıncılar da belirli oranda elmas alacaktır.',
  'lucky_faq7': 'Sıralama Kuralları',
  'lucky_faq8': '1. İstatistik Kuralları',
  'lucky_faq9': 'Günlük ve haftalık oyuna katılarak en çok coins harcayan on kullanıcı Zenginlik Sıralamasında, en yüksek kazanma katlarına sahip on kullanıcı ise Şans Sıralamasında yer alacak.',
  'lucky_faq10': '2. İstatistiksel Döngü',
  'lucky_faq11': 'Günlük sıralama: her gün 0:00 ile 24:00\'a kadar',
  'lucky_faq12': 'Haftalık sıralama: her Pazartesi 0:00\'dan Pazar 24:00\'a kadar',
  'lucky_faq13': '3. Sıralama Ödülleri',
  'lucky_faq14': 'Günlük ve haftalık sıralamada ilk 10\'a girenler aşağıda gösterildiği gibi ödüller alacaktır.',
  'lucky_faq15': 'Günlük Sıralama Ödülleri',
  'lucky_faq16': 'Sıralama',
  'lucky_faq17': 'Haftalık Sıralama Ödülleri',
  'Charge_Same_1': 'Yakın zamanda bu kullanıcıya başarılı bir şekilde aynı miktarda yükleme gönderdin. Tekrar işlem yapmak ister misin?',
  'Charge_Same_2': 'Ödemeyi İptal Et',
  'Charge_Same_3': 'Ödemeye Devam Et',
  'Registr_optimization_1': 'Kayıt ve giriş sorunları',
  'AnchorCenter_biList_interaction_text1': 'Etkileşim',
  'AnchorCenter_biList_interaction_text2': 'Başlatılan Sohbetler (UV)',
  'AnchorCenter_biList_interaction_text3': 'Yanıt Oranı (UV)',
  'AnchorCenter_biList_interaction_text4': 'Yanıt Oranı (PV)',
  'AnchorCenter_biList_interaction_text5': 'Dönüş Oranı (UV)',
  'AnchorCenter_biList_interaction_text6': 'Alınan Mesajlar (UV)',
  'AnchorCenter_biList_interaction_text7': 'Yanıtlanan Mesajlar (UV)',
  'AnchorCenter_biList_interaction_text8': 'Yanıt Oranı (UV)',
  'AnchorCenter_biList_interaction_text9': 'Gönderilen Mesajlar (UV)',
  'AnchorCenter_biList_interaction_text10': 'Yanıtlanan Mesajlarınız (UV)',
  'AnchorCenter_biList_interaction_text11': 'Yanıt Oranı (UV)',
  'AnchorCenter_biList_interaction_text12': 'Gönderilen Mesajlar (PV)',
  'AnchorCenter_biList_interaction_text13': 'Yanıtlanan Mesajlarınız (PV)',
  'AnchorCenter_biList_interaction_text14': 'Yanıt Oranı (PV)',
  'AnchorCenter_biList_interaction_Popup1': 'x\' kullanıcıdan mesaj aldınız',
  'AnchorCenter_biList_interaction_Popup2': 'Size mesaj gönderen \'x\' kişiden \'n\' tanesine yanıt verdiniz',
  'AnchorCenter_biList_interaction_Popup3': 'Örnek: 100 kişiden mesaj aldınız ve bunların 90\'ına etkili bir şekilde yanıt verdiniz. Etkili yanıt oranınız (UV) = 90/100 = %90',
  'AnchorCenter_biList_interaction_Popup4': 'Mesaj Yanıt Yüzdesi (UV)',
  'AnchorCenter_biList_interaction_Popup5': 'Etkili Yanıt Oranı: Yalnızca zaman aşımından önce yanıtlanan kullanıcıları sayar',
  'AnchorCenter_biList_interaction_Popup6': 'Tamam',
  'AnchorCenter_biList_interaction_Popup7': 'x\' kişiye mesaj gönderdiniz',
  'AnchorCenter_biList_interaction_Popup8': 'Mesajlaştığınız \'x\' kişiden \'n\' tanesi size yanıt verdi',
  'AnchorCenter_biList_interaction_Popup9': 'Yanıtlayan Kullanıcıların Yüzdesi (UV)',
  'AnchorCenter_biList_interaction_Popup10': 'Örnek: 100 kişiye mesaj gönderdiniz ve 50 tanesi cevap verdi. Etkili yanıt oranınız (UV) = 50/100 = %50',
  'AnchorCenter_biList_interaction_Popup11': 'Etkili Yanıt Oranı: Yalnızca zaman aşımından önce alınan yanıtları sayar',
  'AnchorCenter_biList_interaction_Popup12': 'x\' mesaj gönderdiniz',
  'AnchorCenter_biList_interaction_Popup13': 'Gönderdiğiniz \'x\' mesajdan \'n\' tanesine etkili bir şekilde yanıt verildi',
  'AnchorCenter_biList_interaction_Popup14': 'Yanıtlanan Mesajlarınızın Yüzdesi (PV)',
  'AnchorCenter_biList_interaction_Popup15': 'Örnek: 100 mesaj gönderdiniz ve bunların 70\'i etkili bir şekilde yanıtlandı. Etkili yanıt oranınız (PV) = 70/100 = %70',
  'AnchorCenter_biList_interaction_Popup16': 'Etkili Yanıt Oranı: Yalnızca zaman aşımından önce alınan yanıtları sayar',
  'program_list_24_ios': 'silin',
  'withdraw_text_26': 'Lütfen ödeme bilgilerini doğrulayın. Yanlış bilgiler, çekim işleminin başarısız olmasına neden olacak ve ek ücretler kullanıcı tarafından karşılanacaktır.',
  'withdraw_text_29': 'İpucu:',
  'withdraw_text_43': 'Bu ödeme yöntemi için tamamlanmamış siparişler bulunmakta ve geçici olarak değiştirilemez veya silinemez.',
  'withdraw_text_44': 'Başarıyla gönderildi!',
  'payment_bind_2': 'Papara Numaranız',
  'payment_bind_2_GPAY': 'Banka İbanı(TL), iban yazılırken arada kalan boşlukları silmelisiniz',
  'payment_bind_3': 'Banka adı',
  'payment_bind_4': 'İsim',
  'payment_bind_5': 'Mail',
  'payment_bind_6': 'Adres',
  'payment_bind_7': '10 hane veya PL artı 10 hane',
  'payment_bind_8': 'TR + 24 hane ile başlar',
  'payment_bind_9': '{n} gerekir',
  'payment_bind_10': 'Silme başarılı',
  'payment_bind_11': 'İsim:',
  'payment_bind_12': 'Soyisim:',
  'Tvwall_gift_9': 'TV duvarında görüntülenecek 2.000 coinse eşit veya daha fazla değere sahip hediye istek listelerini tamamlayın',
  'Tvwall_gift_10': 'Giriş kilit ekranı koşulları:',
  'Tvwall_gift_32': 'Hediye vermek televizyonda gösterilmeli mi?',
  'Tvwall_gift_33': '(Hemen yürürlüğe girmesi için seçmek için tıklayın)',
  'Tvwall_gift_11': 'Ekranı 10 saniye kilitleyin: Bir istek hediyesi tamamlandı ve istek hediyesinin değeri 2000 coins ile 9999 coins arasında;',
  'Tvwall_gift_12': '20 saniye boyunca ekranı kilitle: Bir istek hediyesi tamamlandı ve istek hediyesinin değeri 10.000 coins ile 49.999 coins arasında;',
  'Tvwall_gift_13': '60 saniye boyunca ekranı kilitle: Bir istek hediyesi tamamlandı ve istek hediyesinin değeri 50.000 coinsten fazla',
  'Tvwall_gift_14': 'Global TV Duvarında görünme koşulları:',
  'Tvwall_gift_15': 'Sıradan kayıt: Bir istek hediyesi tamamlandı ve istek hediyesinin değeri 2000 coins ile 9999 coins arasında.',
  'Tvwall_gift_16': 'Lüks rekor: Bir istek hediyesi tamamlandı ve istek hediyesinin değeri 10.000 coinse eşit veya daha fazla',
  'Tvwall_gift_17': 'TV Duvarında',
  'Tvwall_gift_18': 'TV Duvarında Anonim',
  'Tvwall_gift_19': 'TV Duvarında Değil',
  'Admob_text7': 'Görev hazırlanıyor',
  'Admob_text8': 'Video henüz hazır değil',
  'EXP': 'EXP',
  'Experience_Card_Statement': '*Bu avantaj deneyim kartlarında yoktur',
  'Official_website_payment_1': 'Soyou Çevrimiçi Yükleme',
  'Official_website_payment_2': 'Yükleme Kimliği',
  'Official_website_payment_3': 'Kimliği girin',
  'Official_website_payment_4': 'Kimlik nedir?',
  'Official_website_payment_5': 'Lütfen önce hesabın gizliliğini ve güvenliğini korumak için kontrol edin.',
  'Official_website_payment_6': 'Sorgu',
  'Official_website_payment_7': 'Kullanıcı Bildirimi',
  'Official_website_payment_8': '1. Gereksiz anlaşmazlıkları önlemek için resmi olmayan veya yetkisiz web siteleri aracılığıyla Soyou coins satın almayın.',
  'Official_website_payment_9': '2. Diğer web sitelerinde, iletişim kanallarında veya iletişim gruplarında yayınlanan resmi olmayan bilgilere güvenmeyin. Tüm etkinlik bilgileri resmi web sitesi veya sistem içi bildirim aracılığıyla resmi duyuruya tabidir.',
  'Official_website_payment_10': '3. Çevrimdışı işlemler desteklenmez.',
  'Official_website_payment_11': '4. Hesap bilgilerinizi hiçbir nedenle veya hiçbir yöntemle başkasına ifşa etmeyin.',
  'Official_website_payment_12': '5. Soyou, Kullanıcılar ile üçüncü taraf arasındaki herhangi bir anlaşmazlıktan sorumlu tutulamaz.',
  'Official_website_payment_13': '6. Yükleme ile ilgili herhangi bir sorun varsa lütfen müşteri hizmetleriyle iletişime geçin veya bize e-posta gönderin.',
  'Official_website_payment_14': 'Kara Para Aklamayı Önleme',
  'Official_website_payment_15': '1. Kullanıcı, tarafımızca sağlanan hizmetleri kullanmak için yasal bir kimliğe ve kapasiteye sahip olduğundan ve herhangi bir suç faaliyetine katılmayacağından veya bunlarla ilişkilendirilmeyeceğinden emin olmalıdır.',
  'Official_website_payment_16': '2. Kullanıcı hesabı yalnızca sizin kullanımınıza yöneliktir ve yalnızca size aittir. Hesabınızı herhangi bir üçüncü tarafa devredemez, kiralayamaz veya başka şekilde elden çıkaramazsınız. 3.Kullanıcı, yüklemeler için kullanılan tüm paranın yasal yollardan elde edildiğinden ve hiçbir zaman suç teşkil eden bir faaliyet veya davranışla ilişkilendirilmediğinden emin olmalıdır.',
  'Official_website_payment_17': '3.Kullanıcı, yükleme için kullanılan tüm paranın yasal yollarla elde edildiğinden ve hiçbir zaman suç faaliyeti veya davranışıyla ilişkilendirilmediğinden emin olmalıdır.',
  'Official_website_payment_18': 'Ödeme Yöntemi',
  'Official_website_payment_19': 'Şu anda {%s} ödeme kanalı kullanılıyor',
  'Official_website_payment_20': 'Yükleme Seçeneği',
  'Official_website_payment_21': 'Değiştir',
  'Official_website_payment_22': 'Hesap Kimliği mevcut değil!',
  'Official_website_payment_23': 'Henüz desteklenen ödeme yöntemi yok',
  'Official_website_payment_24': 'İstediğiniz ödeme yöntemini geri bildirimde bulunun',
  'Official_website_payment_25': 'İşlem sonuçları sorgulanıyor',
  'Official_website_payment_26': 'Yükleme sonucu onaylanacak',
  'Official_website_payment_27': 'Yükleme sonucu gecikebilir. Hesap yükleme kaydını kontrol etmek için lütfen uygulamaya girin. Hesap uzun süre gelmezse lütfen müşteri hizmetleriyle iletişime geçin.',
  'Official_website_payment_28': 'Yenile',
  'Official_website_payment_29': 'Yükleme başarısız',
  'Official_website_payment_30': 'Yardım bilgileri:',
  'Official_website_payment_31': '1. Lütfen kişisel bilgiler, kredi kartı numarası, geçerlilik süresi, CVV kodu vb. dahil olmak üzere tutarın ve ödeme yönteminin doğru olup olmadığını onaylayın.',
  'Official_website_payment_32': '2. Lütfen hesap bakiyesinin yeterli olup olmadığını kontrol edin.',
  'Official_website_payment_33': '3. Ağ bağlantısının kararlı olup olmadığını kontrol edin. Bazen ağ sorunları ödeme başarısızlığına neden olabilir.',
  'Official_website_payment_34': '4. Başka ödeme yöntemlerine geçmeyi deneyin veya daha sonra yüklemeyi deneyin.',
  'Official_website_payment_35': '5. Sorun hala çözülmediyse, daha fazla yardım için yükleme platformunun müşteri hizmetleriyle iletişime geçmeniz önerilir.',
  'Official_website_payment_36': 'Yükleme başarılı',
  'Official_website_payment_37': 'Hesap yükleme kaydını görüntülemek için lütfen uygulamaya girin',
  'Official_website_payment_38': 'Bağlantı zaman aşımı başarısız',
  'Official_website_payment_39': 'Bağlantının süresi doldu. Lütfen Uygulamada ödeme bağlantısını yeniden oluşturun.',
  'payment_bind_13': 'Contract Address',
  'payment_bind_14': 'Epay Email',
  'payment_bind_15': 'Note: TRC-20 protocol',
  'payment_bind_16': 'Note: Ensure your Epay account is verified',
  'payment_bind_17': 'Contract address starts with T',
  'payment_bind_18': 'Cannot exceed 40 characters',
  'payment_bind_19': 'Must match your Epay account email',
  'payment_bind_20': 'Enter email address',
  'payment_bind_21': 'Gcash account',
  'payment_bind_22': 'Must be 11 digits starting with 09',
  'payment_bind_23': 'Only allow English letters, spaces, hyphens (-), periods (.), and commas (,) and less than 100 characters.',
  'payment_bind_24': 'Bank Tansfer account',
  'payment_bind_25': 'Pix Key (CPF/CNPJ)',
  'payment_bind_26': 'Belge',
  'payment_bind_27': 'Sadece 11 haneye izin verilir',
  'task_miss': 'Kaçır',
  're_signing': 'Yeniden kayıt yao',
  'anchor_task_txt1': 'Eski arkadaşlarınıı {%s1} kez ziyaret et (ve yanıt al), {%s2} 💎elmas kazan.',
  'anchor_task_txt2': 'Yeni kullanıcılarla otrum sayısı >5 {%s1} kez ulaşırsa, {%s2}💎 elmas kazanırsınız.',
  'task_txt21': 'Günlük ceck-in',
  'task_txt22': 'Gökyüzü',
  'task_txt23': 'Oturum aç',
  'task_txt24': 'Görev listesi',
  'task_txt25': 'Yayıncı görevleri',
  'task_txt31': 'Oturum açıldı',
  'sign_in_text3_new': 'Giriş yapın, ödülünüz 2 kat olsun.',
  'Double_Rewards_text1': 'Çift Ödüllü VIP Olun!',
  'family.level.instructions': 'AİLE DÜZEYİNDE TALİMATLAR',
  'family.division.privilege': 'Bölme ve Bölme Ayrıcalığı',
  'family.division.privilege.describe': 'Bölüm, aylık tecrübeye dayalıdır ve her ayın 1\'inde sıfırlanır. Bölüm yükseltebilir, koruyabilir ve düşürebilir. Mevcut rütbeyi korumak yalnızca karşılık gelen yükseltme deneyiminin %100\'üne ulaşmayı gerektirir.',
  'family.diamonds.exch': 'Elmaslar Borsası',
  'family.new.diamonds.exch': 'Rozet',
  'family.label.tag': 'Aile Etiketi',
  'family.label.frame': 'Aile Çerçevesi',
  'family.label.chatroom': 'Sohbet Odası Bg',
  'family.label.familyBg': 'Aile Bg',
  'family.bronze.family': 'Bronz Aile',
  'family.silver.family': 'Gümüş Ailesi',
  'family.golden.family': 'Altın Aile',
  'family.diamond.family': 'Elmas Ailesi',
  'family.king.family': 'Kral Aile',
  'family.task.daily.exp': 'GÜNLÜK EXP',
  'family.task.monthly.exp': 'AYLIK EXP',
  'family.task.exp.describe': 'Aileye kattığınız EXP',
  'family.task.tips': 'Çifte deneyim kazanmak için Aileye katıldıktan sonraki ilk 2 gün içinde görevleri tamamlayın.',
  'family.task.invite.join': 'Arkadaşlarınızı Aileye Katılmaya Davet Edin',
  'family.task.treasure.unlocked': 'Üye sayısı %s\'e ulaşırsa, aile hazine sandığının kilidi her gün sabah 0\'da açılacaktır.',
  'family.task.your.rewards': 'Ödülleriniz',
  'family.task.rules.first': 'Aile hazine sandığının koşulları yerine getirildikten sonra hazine sandığı içindeki ödüller rastgele açılacaktır.',
  'family.task.rules.second': 'Hazine sandığı açılmadan görevi tamamlayan üyeler ödül alacak.',
  'family.task.rules.three': 'Öğeler Kazananların Çantası\'na dağıtılacak ve EXP veya coins gibi diğer ödüller hesaplara dağıtılacaktır',
  'family.task.rules.four': 'Ödüller hazine sandığı açıldıktan sonra otomatik olarak dağıtılacaktır',
  'family.task.captain.task': 'Kaptan Görevi',
  'family.task.treasure.chest': 'Aile Hazinesi Sandığı',
  'family.task.interactive': 'Etkileşimli Görev',
  'family.task.cumulative': 'Birikmiş Görev',
  'family.task.others': 'Diğerleri',
  'family.task.family.level': 'Aile Seviyesi birikmiş tecrübeye dayanmaktadır. Her seviye aşağıdaki ayrıcalığa karşılık gelir.',
  'family.exp.title': 'Aile Deneyim Puanı',
  'family.exp.content.title.1': 'Aile Deneyim Puanı Nasıl Kazanılır',
  'family.exp.content1.text.title.1': 'Aile Üyeleri Hediye gönderir',
  'family.exp.content1.text.1': '{%s1} Coin',
  'family.exp.content1.text.2': '1 Deneyim Puanı',
  'family.exp.content1.text.3': '50 Gem',
  'family.exp.content1.text.title.2': 'Aile Hedieyeleri Hediye Alırken',
  'family.exp.content1.text.title.3': 'Aile Görevlerini Tamamla',
  'family.exp.content.title.2': 'Aile Seviyesi & Seviye ayrıcalıkları',
  'family.exp.table.title.1': 'Deneyim Puanı',
  'family.exp.table.title.2': 'Üye',
  'family.exp.table.title.3': 'Yardımcı Kaptan',
  'family.exp.table.title.4': 'Yönetici',
  'common.EXP': 'EXP',
  'game.task.center.get': 'Al',
  'game.task.center.received': 'Alındı',
  'coupon_pay_txt4': 'coins',
  'coupon_pay_txt2': 'Sadece {%s} için',
  'coupon_pay_txt3': '{%s}% Coins Kuponu',
  'iosso_wallet_txt8': 'Go Back',
  'common.up.SECS': 'SANİYELER',
  'recharge.event.Recharge': 'Yükle',
  'recharge.event.hidden': 'Bilgileri Gizle',
  'report.option.child': 'Çocuklarla ilgili',
  'lucky.vs.camp.select': 'Kamp Seçimi',
  'lucky.vs.camp.select.text.1': 'Kazanan kamplara en çok katkıda bulunan 5 kişi coins ödülleri alabilir!',
  'lucky.vs.camp.select.text.2': 'Hangi kampa katılmak istiyorsunuz?',
  'lucky.vs.camp.select.text.3': 'İPUÇLARI: Her kişi etkinlik süresi boyunca yalnızca bir kez kamp değiştirebilir.',
  'lucky.vs.camp.edit.text.1': 'Kamp Değiştir',
  'lucky.vs.camp.edit.text.2': 'Kampı değiştirmek istediğinizden emin misiniz? Her kişi kampı yalnızca bir kez değiştirebilir.',
  'lucky.vs.camp.edit.text.3': 'EVET',
  'lucky.vs.camp.edit.text.4': 'HAYIR',
  'lucky.vs.camp.opponent': 'Rakibin Kampı',
  'lucky.vs.camp.me': 'Kampımız',
  'lucky.vs.camp.join': 'Katıl',
  'lucky.vs.camp.Eagle': 'Kartal Sıralaması',
  'lucky.vs.camp.Lion': 'Aslan Sıralaması',
  'lucky.vs.out.tab.left': 'Hazine Kutusu',
  'lucky.vs.out.tab.right': 'Kartal VS Aslan',
  'lucky.vs.reward.extra': 'Kartal VS Aslan Bonusu',
  'lucky.vs.ext.text.tip': '{N} coinslere ulaşan aşağıdaki ödülleri alabilir.',
  'world.cup.records': 'Kayıtlar',
  'kill.monster.congratulations': 'Tebrikler!',
  'world.cup.time': 'Zaman',
  'common.cap.Rewards': 'Ödüller',
  'common.number': 'Sayı',
  'activity.gift.list.contributor': 'Katkı Sağlayan\nSıralama',
  'activity.gift.list.stars': 'Yıldızlar\nSıralama',
  'activity.gift.list.send': 'Katkı Sağlayan',
  'activity.gift.list.receive': 'Yıldızlar',
  'common.cap.Rights': 'Tüm Hakları Tarafından Saklıdır',
  'biu.biu.building.ranking.list': 'Sıralama listesi',
  'biu.biu.building.car.detail': 'Araç detayları',
  'biu.biu.building.detail.coin': '{$month}-{$day} {$hour}:{$min}, {$coin} coins yeniden yüklediniz.',
  'biu.biu.building.detail.floors.one': '{$month}-{$day} {$hour}:{$min}, {$count} {$level} {$cars} savaştınız ve {$floornumer} {$floor} yok ettiniz.',
  'biu.biu.building.rush.button': 'Go*{$times}',
  'biu.biu.building.can.rush.one': 'Olası çarpışma sayısı: Seviye 1 araç*{$times}',
  'biu.biu.building.can.rush.two': 'Seviye 2 araçlar*{$times}',
  'biu.biu.building.one.car': 'Seviye1 Araba',
  'biu.biu.building.two.car': 'Seviye2 Araba',
  'biu.biu.building.to.war': 'Go',
  'biu.biu.building.recharge': '{$value}coin/{$count} kez yeniden yükleme yapın',
  'biu.biu.building.daily.list': 'Günlük liste',
  'biu.biu.building.all.list': 'Genel liste',
  'biu.biu.building.car.not.enough': 'Mevcut araç sayısı yetersiz',
  'biu.biu.building.to.get': 'almak için',
  'biu.biu.building.congra': 'Tebrikler!',
  'biu.biu.building.to.collect': 'TAMAM',
  'biu.biu.building.get.reward': 'Ödülünüz!',
  'biu.biu.building.ruls.reward': 'Kurallar&Ödüller',
  'biu.biu.building.no.records': 'Kayıt yok',
  'biu.biu.building.no.lucky': 'Şansızlık',
  'biu.biu.building.no.start': 'Bu aşama başlamak üzere',
  'biu.biu.building.floor.single': 'Kat',
  'biu.biu.building.floor.double': 'Katlar',
  'biu.biu.building.car.single': 'Araba',
  'biu.biu.building.car.double': 'Arabalar',
  'annual.ranking.surprise.store': 'Sürpriz Mağaza',
  'annual.ranking.daily.task': 'Günlük görev',
  'annual.ranking.ticket': 'Bilet',
  'annual.ranking.daily.ranking': 'Günlük Sıralama',
  'annual.ranking.total.ranking': 'Toplam Sıralama',
  'annual.ranking.current.tickets': 'Güncel Biletler',
  'annual.ranking.points': 'Puan',
  'annual.ranking.open': 'Açık',
  'annual.ranking.collect': 'topla',
  'annual.ranking.unfinished': 'Bitmemiş',
  'annual.ranking.exchange': 'Dönüşüm',
  'annual.ranking.confirm': 'Onayla',
  'annual.ranking.to.bag': 'Değiştirilen ürünler çantada görülebilir',
  'annual.ranking.exchange.maximum': 'Değişim tutarı bugün maksimuma ulaştı',
  'annual.ranking.limited': 'Sınırlı',
  'annual.ranking.slod.out': 'HEPSİ SATILDI',
  'annual.ranking.stock': 'Stok',
  'annual.ranking.return': 'Geri dönmek',
  'annual.ranking.fortune.wheel': 'Şans Çarkı',
  'annual.ranking.record': 'Kayıt',
  'annual.ranking.exchange.amount': 'Değişim tutarı',
  'annual.draw.1.time': '{N} kez çek',
  'annual.draw.10.time': '{N} kez çek',
  'annual.draw.record.text': 'Tebrikler! Aldınız',
  'annual.draw.pop.to.get': 'Almak',
  'annual.draw.pop.no.times': 'Yetersiz çekme süreleri',
  'annual.draw.pop.no.record': 'Henüz kayıt yok.',
  'annual.draw.pop.rewards.title': 'Tebrikler!',
  'annual.draw.pop.oppos': 'Oppos!',
  'annual.ranking.union.achor': 'Yılın Yayıncısı',
  'annual.ranking.union.agency': 'Yılın Ajansı',
  'annual.ranking.union.target': 'Hedef',
  'annual.ranking.task.confirm': 'Şimdi {$count}x puan modunun keyfini çıkaracağınızdan emin misiniz?',
  'annual.ranking.union.id': 'Ajans ID',
  'annual.ranking.icon': 'Simge',
  'annual.ranking.num': 'Sayılar',
  'annual.ranking.success': 'Başarılı',
  'lucky.draw.tab.ranking': 'Sıralama',
  'lucky.draw.exchange.shop': 'Bilet Dükkanı',
  'lucky.draw.exchange.shop.val': 'Sikke değeri{%d}',
  'lucky.draw.exchange.shop.exchange': 'değişim',
  'lucky.draw.my.times': 'Benim zamanlarım',
  'lucky.draw.rare': 'Nadir',
  'lucky.draw.exchange.records': 'Kayıtlar',
  'lucky.draw.exchange.records.time': 'zaman',
  'lucky.draw.exchange.records.consume': 'tüketim',
  'lucky.draw.exchange.records.commodity': 'ürün',
  'lucky.draw.confirm': 'Lütfen onaylayın',
  'lucky.draw.confirm.text': 'Takas için TicketX{%d} harcayacağınızdan emin misiniz?',
  'lucky.draw.confirm.success': 'başarılı bir şekilde',
  'common.cap.Go': 'Git',
  'lucky.draw.rules.1': 'Etkinlik sonunda sıralamadaki ilk 3\'e aşağıdaki ödüller verilecek:',
  'lucky.draw.rules.2': 'Not: Etkinlik sonunda kullanılmayan çekiliş hakları sıfırlanacaktır',
  'common.cap.Follow': 'Takip',
  'gift.list.plus.up.need': 'fazla',
  'spring.cp.rewards.wedding.tips': 'Düğüne ev sahipliği yapan iki kullanıcı 30 gün ile sınırlı sayıda olan avatar kampanyasından faydalanabilir.',
  'spring.cp.tab.rose.ranking': 'Gül Sıralaması',
  'spring.cp.tab.rose.ranking.daily': 'Günlük Sıralama',
  'spring.cp.tab.rose.ranking.daily.toast': 'Tarih gelmedi',
  'spring.cp.tab.rose.ranking.daily.tips': 'Bu hediyeyi göndererek bugün %{%d} ekstra gül elde edebilirsiniz',
  'spring.cp.tab.rose.ranking.total': 'Toplam Sıralama',
  'spring.cp.tab.cruise.ranking': 'Kale Düğünü',
  'spring.cp.no.people': 'Bekleniyor',
  'spring.cp.no.cp': 'Henüz başkalarına Sevgililer Gününe özel hediyeler göndermediniz.',
  'spring.cp.wait.wedding': 'Düğün 15 Şubat\'ta başlayacak.',
  'spring.cp.cruise.rule.tips': 'Etkinlik boyunca en çok sınırlı sayıda üretilmiş hediyeyi değiş tokuş eden ve en çok gül toplayan çift, 15 Şubat\'ta şatoda düğün yapma hakkı kazanacak.',
  'spring.cp.cruise.my.cp': 'Benim CP\'m',
  'spring.cp.cruise.find.my.cp': 'CP\'imi bul',
  'spring.cp.cruise.bless': 'Kutsamak için tıklayın',
  'spring.cp.cruise.bless.my.times': 'Benim zamanlarım',
  'spring.cp.cruise.bless.status.1': 'Alındı',
  'spring.cp.cruise.bless.status.2': 'Hesaplanmamış',
  'spring.cp.cruise.bless.click.desc': '{N} defa tıklarsan {name} {time} alabilirsin',
  'common.cap.Start': 'başla',
  'common.cap.Close': 'Yakın',
  'common.cap.next.round': 'Next round will coming soon…',
  'ramadan.new.waiting': 'Bekliyor',
  'ramadan.new.rank.tab.receive': 'Büyüleyici Sıralaması',
  'ramadan.new.rank.tab.give': 'Zenginlik Sıralaması',
  'ramadan.new.rank.daily': 'Günlük Sıralama',
  'ramadan.new.rank.total': 'Toplam Sıralama',
  'ramadan.new.rank.daily.desc': 'Günlük TOP1 kullanıcısı ilgili ödülleri alabilir.',
  'ramadan.new.rank.tips': 'Bu aşama başlamak üzere',
  'ramadan.new.honor.times': '{n}kez',
  'ramadan.new.honor.time': '{n}kez',
  'ramadan.new.honor.countdown.waiting': 'Etkinlik başlamak üzere',
  'ramadan.new.honor.countdown.ing': 'Geri sayım',
  'ramadan.new.honor.countdown.over': 'Etkinlik sona erdi',
  'ramadan.new.honor.desc': 'Oda onuru penceresi, tüm platformlarda her {N} sınırlı hediye için bir kez açılacaktır.',
  'ramadan.new.honor.toTop1.time': '<span class=\'span\'> {N} </span> kere ihtiyaç var',
  'ramadan.new.honor.toTop1.times': '<span class=\'span\'> {N} </span> kere ihtiyaç var',
  'ramadan.new.honor.my.times': 'Saatlerim',
  'ramadan.new.event.start': 'Etkinlik başlamak üzere',
  'ramadan.new.my.tickets': 'Biletlerim',
  'ramadan.new.estimated.win': 'Tahmini galibiyet',
  'ramadan.new.prize.content': 'Almış olduğunuz',
  'ramadan.new.collect': 'Topla',
  'ramadan.new.tab1': 'Ramazan Girişi',
  'ramadan.new.sign.day': '{N} gün boyunca oturum açın',
  'ramadan.new.collected': 'Toplanmış',
  'ramadan.new.today.content': 'Bugün oturum açarak şunları elde edebilirsiniz:',
  'ramadan.new.ok': 'TAMAM',
  'ramadan.new.bottom.desc': 'Günde bir kez geri yükleme yapın ve bir kerelik tekrar giriş yapabilirsiniz',
  'ramadan.new.resign.btn': 'Talep et',
  'ramadan.new.resign.content': 'Başarılı bir yeniden giriş şunları kazanır:',
  'ramadan.new.resign.fail.content': 'Günde bir kez geri yükleme yapın ve bir kez yeniden giriş yapabilirsiniz. (Bayilerden satın alınan coinsler sayılacaktır; Bayiler tarafından platformdan yapılan satın alma işlemleri sayılmayacaktır.)',
  'ramadan.new.resign.fail.btn': 'Şimdi Yükleyin',
  'ramadan.new.tab2': 'Duacı Sıralaması',
  'ramadan.new.tab3': 'Kutsanmış Onur',
  'ramadan.new.next': 'SONRAKİ',
  'ramadan.new.back': 'Geri',
  'ramadan.new.not.remain': 'Bir daha gösterme.',
  'ramadan.new.had.sign': 'Bugün yeniden giriş yaptınız.',
  'ramadan.new.nickname': 'Kullanıcı Adı',
  'lasser.bairam.collect': 'Topla',
  'lasser.bairam.ok': 'TAMAM',
  'lasser.bairam.waiting': 'Bekleniyor',
  'lasser.bairam.special.gift.title': 'Zenginlik Hazine Kutusu',
  'lasser.bairam.special.gift.to.be.drawn': 'Çekilecek',
  'lasser.bairam.special.gift.to.complete': 'Şimdi tamamla',
  'lasser.bairam.special.gift.contribution': 'Katkı Sandığı',
  'lasser.bairam.special.gift.lucky': 'Şanslı Bayram Sandığı',
  'lasser.bairam.special.gift.desc': 'Biriken sınırlı hediye değeri {d} elmas, şanslı yıldızların seçimine katılabilir ({z}/{m})',
  'lasser.bairam.tab.scene': 'Bayram Gezisi',
  'lasser.bairam.tab.ranking': 'Sıralama',
  'lasser.bairam.scene.tips': 'Her yerde geçerli sınırlı hediyeler dağıtın, sahnelerin kilidini açmak ve ödüller kazanmak için karşılık gelen sayıda coinse ulaşın. Ayrıca MVP\'lerin ek ödülleri bulunmaktadır.',
  'lasser.bairam.scene.rewards.desc': 'Mevcut sahnenin kilidini açmaya katıldıktan sonra aşağıdaki ödülleri alabilirsiniz ve MVP\'nin ek ödülleri bulunmaktadır.',
  'lasser.bairam.scene.unlock.modal.title': 'Konum kilidini açmaya katıldığınız için tebrikler:',
  'lasser.bairam.scene.unlock.modal.you.can.get': 'Alabilir',
  'lasser.bairam.scene.unlock.modal.mvp.tag': 'MVP alabilir',
  'lasser.bairam.rewards.tips': 'Bu sayfada genel sıralama ödülleri gösterilmektedir. Coins ödüllerini nasıl kazanacağınıza dair ayrıntılar için lütfen kurallar sayfasına bakın.',
  'lasser.bairam.go.look': 'Şimdi kontrol et!',
  'lasser.bairam.no.time.yet': 'Süre dolmadı',
  'lasser.bairam.next.round': 'Gelecek Round',
  'lasser.bairam.ranking.tab.send': 'Alınan Hediye Sıralaması',
  'lasser.bairam.ranking.tab.receive': 'Gönderilen Hediye Sıralaması',
  'common.cap.Success': 'Başarılı',
  'family.football.no.tips': 'Bir dahaki sefere başka ipucu yok',
  'common.cap.Record': 'Kayıtlar',
  'coins.battle.time': 'Kez',
  'coins.battle.times': 'Kez',
  'coins.battle.draw.total.coins': 'Birikmiş:<span class=\'num\'>{totalRechargeCoins}</span>coins',
  'coins.battle.draw.remain.times': 'Kalan Hak: {remainTime} kez',
  'coins.battle.draw.no.recharge': 'İlk çekiliş için yalnızca {coinToDrawCount} coins yüklemeniz gerekiyor.',
  'coins.battle.draw.recharged': '{coinToDrawCount} toplam coin yüklemesi: Çekiliş hakkı +1',
  'coins.battle.draw.drawing.tips': 'Çekiliş İpuçları',
  'coins.battle.draw.drawing.tips.desc': 'Yetersiz çekiliş hakkı! Daha fazla hak kazanmak için şimdi yükleme yapın',
  'coins.battle.draw.drawing.tips.recharge.now': 'Şimdi Yükleme Yapın',
  'coins.battle.task.title': 'Görev Görüntüleme Alanı',
  'coins.battle.task.go': 'İlerle',
  'coins.battle.task.completed': 'Tamamlandı',
  'coins.battle.task.tips': 'Tamamladığınız her görev bir çekiliş hakkı kazandırır.',
  'coins.battle.entry.title': 'Sürpriz Avantajlar',
  'coins.battle.entry.desc': '1 milyona kadar coins kazanma şansın var!',
  'coins.battle.entry.btn': 'Kazanmak için {coinToDrawCount} coins yükle',
  'coins.battle.rules.not.show.again': 'Bir daha gösterme',
  'coins.battle.result.title': 'Tebrikler!',
  'coins.battle.result.prize.pool': 'Ödül havuzunun % {N}\'ini kazanın',
  'coins.battle.result.get': 'alın',
  'coins.battle.record.tab.draw.record': 'Çekiliş Geçmişi',
  'coins.battle.record.tab.number.of.draws': 'Çekiliş Hakkı',
  'coins.battle.record.head.time': 'Zaman',
  'coins.battle.record.head.coins.or.tasks': 'Coins/Görevler',
  'coins.battle.record.complete.task': 'Görev {N}\'i tamamla',
  'common.cap.Coins': 'Coins',
  'common.cap.time': 'Zaman',
  'common.cap.times': 'Haklar',
  'common.cap.my.times': 'Çekiliş sayım',
  'common.cap.Sure': 'ELBETTE',
  'common.cap.not.remind': 'Başka hatırlatıcı yok',
  'lucky.draw.may.tab.draw': 'Mekanik Çekiliş',
  'lucky.draw.may.tab.vote': 'Mekanik Star',
  'lucky.draw.may.tab.ranking': 'Sıralama',
  'lucky.draw.may.draw.draw.times': 'Şanslı çekilişler {%d}',
  'lucky.draw.may.draw.draw.tips': '{%d}coins karşılığında sınırlı hediyeler göndererek çekiliş şansı yakalayabilirsiniz',
  'lucky.draw.may.confirm.text': 'Çekiliş için {%s} x{%d} harcayacağınızdan emin misiniz?',
  'lucky.draw.may.vote': 'Oy',
  'lucky.draw.may.vote.top3.title': 'Top3 Ödülleri',
  'lucky.draw.may.vote.top3.tips': 'Daha çok ödül kazanmak için lütfen kurallar sayfasından detaylara ulaşın.',
  'lucky.draw.may.vote.please.enter.id': 'Lütfen ID girin',
  'lucky.draw.may.vote.tips': '{%d} coinsle sınırlı hediyeler göndererek 1 bilet alabilirsiniz',
  'lucky.draw.may.vote.search.tips': 'Yalnızca yayıncılara oy verilebilir.',
  'lucky.draw.may.vote.cur.ranking': 'mevcut sıralama:{%d}',
  'lucky.draw.may.vote.voting.record': 'Oylama kaydı',
  'lucky.draw.may.vote.voting.record.user': 'kullanıcı',
  'lucky.draw.may.vote.voting.record.number': 'oy sayısı',
  'lucky.draw.may.rewards.tips': 'Ödüllerin nasıl alınacağına ilişkin ayrıntılı kurallar için lütfen kurallar sayfasına gidin.',
  'lucky.draw.may.unlock': 'Kilidini aç',
  'lucky.draw.may.unlock.some': '{%s}% kilidini açtığınız için tebrikler,Bu ödülleri alın~',
  'lucky.draw.may.unlock.all': 'Bulmacanın tüm kilidini açtığınız için teşekkür ederiz, tüm ödülleri alın',
  'lucky.draw.may.result.tips': 'Bulmacanın kilidini açmak için {%s} kullanılacak',
  'common.cap.confirm': 'Onayla',
  'common.cap.cancel': 'İptal Et',
  'common.cap.month1': 'Ocak',
  'common.cap.month2': 'Şubat',
  'common.cap.month3': 'Mart',
  'common.cap.month4': 'Nisan',
  'common.cap.month5': 'Mayıs',
  'common.cap.month6': 'Haziran',
  'common.cap.month7': 'Temmuz',
  'common.cap.month8': 'Ağustos',
  'common.cap.month9': 'Eylül',
  'common.cap.month10': 'Ekim',
  'common.cap.month11': 'Kasım',
  'common.cap.month12': 'Aralık',
  'fes.of.sa.not.start': 'Etkinlik başlamak üzere',
  'fes.of.sa.tab1': 'Kuzu Çevirme Yarışı',
  'fes.of.sa.tab2': 'Çılgın Kuzu Evi',
  'fes.of.sa.free': 'ÖZGÜR!',
  'fes.of.sa.collect.tools': 'Kuzu Çevirme yapmak için gerekli araçları toplayın',
  'fes.of.sa.combine': 'Birleştir',
  'fes.of.sa.count': 'X{N}',
  'fes.of.sa.ranking': 'Sıralama',
  'fes.of.sa.tip.text': 'Birleştirilecek {N}\'dan fazla kuzunuz var, şimdi birleştirilsin mi?',
  'fes.of.sa.ok': 'TAMAM',
  'fes.of.sa.records': 'Kayıtlar',
  'fes.of.sa.draw': 'Çekiliş {%d}',
  'fes.of.sa.ticket.enough': 'Biletler yetersiz, daha fazla kazanmak için hediye gönder!',
  'fes.of.sa.draw.again': 'Tekrar çek',
  'fes.of.sa.time': 'Zaman',
  'fes.of.sa.recharge.btn': 'Yükleme Yap',
  'fes.of.sa.send.btn': 'Gönder',
  'fes.of.sa.rank.tab1': 'Kuzu Çevirme Sıralaması',
  'fes.of.sa.rank.tab2': 'Cazibe Sıralaması',
  'fes.of.sa.rank.daily': 'Günlük',
  'fes.of.sa.rank.total': 'Toplam',
  'fes.of.sa.lamb.top': 'Kuzuları ücretsiz yakala 5 kat sıralama puanı kazan',
  'fes.of.sa.unlock.btn': 'KİLİDİ AÇMAK İÇİN HEDİYE GÖNDER',
  'fes.of.sa.wait.lock': 'AÇILSIN!',
  'fes.of.sa.catch.btn': 'YAKALA ({N})',
  'fes.of.sa.lamb.rewards': 'KUZU EVİNDEN ÜCRETSİZ HEDİYE',
  'fes.of.sa.catch.suc.title': 'Başarıyla Yakaladın!',
  'fes.of.sa.catch.suc.text': 'Tebrikler! 1 ücretsiz kuzu kazandınız!\nKuzu Evinden ücretsiz kuzular, Kuzu Sıralamasında 5 kat puan sayılacaktır!',
  'fes.of.sa.catch.cong.title': 'Tebrikler!',
  'fes.of.sa.catch.cong.text': 'Bu sefer kuzu yakalayamadık, size en iyi dileklerimizi ve bir hediyemizi daha gönderiyoruz!',
  'fes.of.sa.catch.oops': 'Hay aksi..',
  'fes.of.sa.catch.oops.text': 'Bu sefer ödül alamadınız, TalkTalk size en iyi dileklerini iletiyor! Tekrar deneyin!',
  'fes.of.sa.event.gift': 'Etkinlik Ödülü',
  'game.king.prize.pool': 'Ödül havuzu',
  'game.king.tab1': 'Taht Kavgası',
  'game.king.tab2': 'Cesur Ejderha Adası',
  'game.king.game.king': 'OYUN KRALI',
  'game.king.bounds.gold': 'Bonus Altın',
  'game.king.score': 'SKOR',
  'game.king.king.desc': 'Bu tur için puanlar',
  'game.king.king.reward': 'Kral\'ın Ödülü',
  'game.king.you.is.king': 'OYUNLARIN KRALI SİZSİNİZ',
  'game.king.will.start': 'BAŞLAMAK ÜZERE',
  'game.king.brave.dragon.island': 'CESUR EJDERHA ADASI',
  'game.king.cur.strogest': 'Şu Anki En Güçlü',
  'game.king.attack': 'saldırı',
  'game.king.unused.battle': 'Kullanılmayan Savaş Puanları',
  'game.king.current.battle': 'Mevcut savaş değeri',
  'game.king.strongest.warrior': 'En Güçlü Savaşçı',
  'game.king.lucky.warrior': 'Şanslı Savaşçı',
  'game.king.last.warrior': 'Son Vuruş Savaşçıları',
  'game.king.warrior.ranking': 'Savaşçı Sıralaması',
  'game.king.spend.attack': 'Saldırmak için {N} savaş gücünün harcanıp harcanmayacağı',
  'game.king.not.reminder': 'Başka hatırlatıcı yok',
  'game.king.reminder': 'Hatırlatma',
  'game.king.go.center': 'Sevgili kullanıcımız, savaş gücün yetersiz. Savaş gücü elde etmek için lütfen oyuna katıl.',
  'game.king.get.rewards': 'Ödül Al',
  'game.king.other.king.rewards': '{nickname} adlı kişiyi {Awardname} olduğu ve {receiveCoin} coins kazandığı için tebrik ederiz!',
  'game.king.reward.name': 'Ödül Adı',
  'game.king.reward': 'Ödüller',
  'game.king.award.time': 'Ödül Zamanı',
  'game.king.warrior.rewards': 'Savaşçı Ödülleri',
  'game.king.self.king.rewards': '{Awardname} olduğunuz ve {receiveCoin} coins kazandığınız için tebrikler',
  'game.king.warrior.dialog.text': '{time} tarihinde {Awardname} olduğunuz ve {receiveCoin} coins kazandığınız için tebrikler!',
  'game.king.king.model.coin': 'Taht Savaşı: Altın Kazanmak {receiveCoin}',
  'game.king.king.model.times': 'Bugün oyunun kralı olma sayınız: {amount}',
  'game.king.divide.pool': 'Coins havuzunu bölüştürün*{receiveCoin}',
  'game.king.cog': 'Tebrikler!',
  'game.king.end.desc': 'Sevgili Cesur Savaşçı\nSavaşçı Sıralamasındaki #{rankings} başarınızdan ve aşağıdaki ödülleri kazandığınızdan dolayı tebrik ederiz',
  'game.king.yes': 'EVET',
  'game.king.no': 'HAYIR',
  'game.king.become.self': '{Awardname} olduğunuz için tebrikler',
  'game.king.become.nick': '{Awardname} olduğu için {nickname}\'i tebrik ederiz',
  'game.list.play.now': 'Git oyunu oyna',
  'game.list.rewards.coin.reward.title': 'Coins ödülleri',
  'game.list.rewards.coin.reward.tag': 'Sınıra ulaşma',
  'game.list.rewards.prop.reward.title': 'Çanta ödülleri',
  'jungle.e.not.start': 'Etkinlik başlamak üzere',
  'jungle.e.tab1': 'Kuzu Çevirme Yarışı',
  'jungle.e.tab2': 'Sıralama',
  'jungle.e.tab3': 'Çılgın Kuzu Evi',
  'jungle.e.tool.title': 'Kuzu Çevirme yapmak için gerekli araçları toplayın',
  'jungle.e.combine': 'Birleştir',
  'jungle.e.times': 'X{N} kere',
  'jungle.e.treasure': 'X{N}',
  'jungle.e.tip.desc': 'Birleştirmek için {N} adetten fazla sandığın var, şimdi birleştirmek ister misin?',
  'jungle.e.ok': 'TAMAM',
  'jungle.e.collect.title': 'Alev Koleksiyonu',
  'jungle.e.collect.desc': 'Günlük Alev toplayarak özel hediye kazan ve Cazibe Sıralaması puanlarını {N} kat artır!',
  'jungle.e.day.refresh': 'Günlük da yenilenir',
  'jungle.e.record': 'Kayıtlar',
  'jungle.e.draw.time': 'Çekiliş {%d}',
  'jungle.e.ticket.enough': 'Yetersiz Macera Kartı',
  'jungle.e.win.desc': 'Bu ödülleri kazandığınız için tebrikler',
  'jungle.e.draw.again': 'Tekrar çek',
  'jungle.e.time': 'Zaman',
  'jungle.e.rechrge': 'Yükleme Yap',
  'jungle.e.send': 'Gönder',
  'jungle.e.sec.tab1': 'Kuzu Çevirme Sıralaması',
  'jungle.e.sec.tab2': 'Cazibe Sıralaması',
  'jungle.e.daily': 'Günlük',
  'jungle.e.Total': 'Toplam',
  'jungle.e.self.last': 'Bir öncekinden {N}',
  'jungle.e.target': 'Sınır: {N}',
  'jungle.e.coin.reach': 'Süper Coins Sandığı açmak için tüm Üyelerin Hediyeleri {N}\'e ulaşır',
  'jungle.e.coin.finish': 'Daha fazla Hazine Sandığı birleştir, Süper Coins Sandığından daha fazla coins kazan!',
  'jungle.e.coin.reach.anchor': 'Alınan hediyelerin toplam sayısı {N}\'a ulaştığında Süper Elmas Sandığının kilidini açılır',
  'jungle.e.coin.finish.anchor': 'Daha fazla etkinlik hediyesi alın ve daha fazla elmas paylaşın!',
  'jungle.e.wating.unlocked': 'Kilidi açılacak ödül havuzu miktarı',
  'jungle.e.pool.amount': 'Toplam Ödül Havuzu Miktarı',
  'jungle.e.divied.coin': 'Şu anda paylaşılabilir: {N} coins',
  'jungle.e.divied.coin.anchor': 'Currently you can share {N} diamonds',
  'jungle.e.send.lock': 'Açmak için {N} coins daha gönder',
  'jungle.e.send.lock.anchor': 'Açmak için {N} hediye daha al',
  'jungle.e.btn.finish': 'Daha fazla etkinlik hediyesi gönderin, daha fazla coins paylaşın>>',
  'jungle.e.btn.finish.anchor': 'Daha fazla aktif hediye alın ve daha fazla elmas paylaşın!',
  'jungle.e.coin.rewards': 'Süper Kutu Ödülleri',
  'jungle.e.winner.list': 'Kazanan Listesi',
  'jungle.e.win': 'KAZANAN',
  'jungle.e.event.gift': 'Etkinlik Hediyesi',
  'jungle.e.cong.title': 'Tebrikler!',
  'crazy.bulider.ranking': 'Sıralama',
  'crazy.bulider.daily.top1': 'Günlük TOP1',
  'crazy.bulider.floors.n': 'Katlar{N}',
  'crazy.bulider.build.n': '{N} Kez İnşa Et',
  'crazy.bulider.build.all': 'Hepsini İnşa Et',
  'crazy.bulider.luck.gift.desc': 'Her {N} coinslik şanslı hediye gönderimi = 1{hammerIcon}',
  'crazy.bulider.rewards.tab1': 'Kat Ödülleri',
  'crazy.bulider.rewards.tab2': 'Sıralama Ödülleri',
  'crazy.bulider.daily': 'Günlük Sıralama',
  'crazy.bulider.total': 'Toplam Sıralama',
  'crazy.bulider.congura': 'Tebrikler!',
  'crazy.bulider.model.rewards.desc': 'Ödül Kazandın!',
  'crazy.bulider.ok': 'Tamam',
  'crazy.bulider.opps': 'Olamaz!',
  'crazy.bulider.time.not.desc': 'İnşa süren yetersiz!<br/>Büyük ödül seni bekliyor, süre kazan!',
  'crazy.bulider.get.more': 'DAHA ÇOK AL',
  'crazy.bulider.celebrate.desc': '{N} kat inşa ettiğin için tebrikler!',
  'crazy.bulider.lucky.moment': '⭐️Şanslı An⭐️',
  'crazy.bulider.lucky.desc': 'Bonus kazanmak için 1 Şanslı Çanta seçin!',
  'crazy.bulider.click.celebrate': 'Kutlama için Tıkla',
  'crazy.bulider.waiting': 'Bekleyin',
  'crazy.bulider.status.start': 'Etkinlik başlamak üzere',
  'crazy.bulider.status.end': 'Etkinlik biti',
  'crazy.bulider.status.count': 'Geri sayım',
  'crazy.bulider.share.moment': 'Anlarda paylaş',
  'crazy.bulider.share': 'Paylaş',
  'crazy.bulider.share.ok': 'Tamam',
  'crazy.bulider.share.desc1': 'Yüzde 90\'dan fazlasını inşa ettin! Mevcut sahneyi arkadaşlarınızla hızlıca paylaşın',
  'crazy.bulider.share.desc2': 'Moment\'e ilk kez başarılı paylaşımda bulunarak süper inşaatçılar için özel ödüller kazanabilirsiniz ↓.,',
  'crazy.bulider.share.desc3': '{X} kişisi de anınızı görerek binalar inşa etmeye başlar',
  'crazy.bulider.share.desc4': 'Etkili olduğun için teşekkürler!',
  'crazy.bulider.share.desc5': 'Gökdelenler kontrolüm altında!',
  'crazy.bulider.share.reward': 'Ödül kazandın',
  'crazy.bulider.progress.current': 'Mevcut:{M}={N}',
  'crazy.bulider.progress.target': 'Hedef',
  'crazy.bulider.share.text': '#👷Çılgın İnşaatçı🚧#\nDünyayı etkileyen süper güç! 🌏\n{N} kat heyecanla inşa edildi🔥\nToplam sıralama: #{Rank} 👑\nKendi gökdelenini inşa etmek için harika bir fırsat!🏙',
  'crazy.bulider.share.success': 'Paylaşım başarıyla yapıldı!',
  'speed.passion.race': 'Yarış',
  'speed.passion.ranking': 'Sıralama',
  'speed.passion.change': 'Değiştir',
  'speed.passion.Completed': 'Tamamlandı',
  'speed.passion.daily.task': 'Günlük Görev',
  'speed.passion.go.for.it': 'Tamamla',
  'speed.passion.Done': 'Tamamlandı',
  'speed.passion.winning.TOP1': 'Kazanan TOP1',
  'speed.passion.Daily.Rewards': 'Günlük Ödüller',
  'speed.passion.naming.unnamed': 'İsimsiz',
  'speed.passion.naming.desc': 'Kampanya süresince bu hediyeyi en çok gönderen kişi bir sonraki hafta bu hediyeyi taçlandıracak!',
  'speed.passion.naming.progress': 'İsim İlerlemesi',
  'speed.passion.naming.progress.get.the.number': 'Numara al',
  'speed.passion.naming.progress.no.one.get': 'Henüz kimse alamadı, sen kazan!',
  'speed.passion.limited.desc': 'İsim hakkı kazanan kullanıcılar, isimli hediyeler gönderip {N} kat mil kazanabilir',
  'speed.passion.change.change.group': 'Grubu değiştir',
  'speed.passion.change.change.desc': 'Bu gruba geçmek istediğinizden emin misiniz?',
  'speed.passion.change.change.ps': 'Not: Grup değiştirdikten sonra bu grubun tüm ödülleri geçersiz olacak.',
  'speed.passion.Result': 'Sonuç',
  'speed.passion.Result.win': 'Dün {N}\'i birinci geldiği için tebrik ediyoruz, ödülleri alın!',
  'speed.passion.Result.lose': 'Dün hiçbir takım kazanamadı, o yüzden bugün tekrar deneyelim.',
  'speed.passion.Result.ps': 'Not: Sadece kazanan grubun Birinci*si ekstra ödüller kazanacak!',
  'speed.passion.choice.group': 'Grup seç',
  'speed.passion.choice.group.desc': 'Gruba katıldıktan sonra alınabilir',
  'speed.passion.rank.daily': 'daily',
  'speed.passion.rank.total': 'Toplam',
  'speed.passion.rank.not.time': 'Henüz tarih erken.',
  'speed.passion.rank.Mileage': 'Mil:',
  'speed.passion.rank.no.rank': 'Grubum',
  'family.battle.new.up.need.s': '{N} ihtiyaç var',
  'hungry.ghost.collect': 'Topla',
  'hungry.ghost.ok': 'TAMAM',
  'hungry.ghost.waiting': 'Bekleniyor',
  'hungry.ghost.special.gift.title': 'Zenginlik Hazine Kutusu',
  'hungry.ghost.special.gift.to.be.drawn': 'Çekilecek',
  'hungry.ghost.special.gift.to.complete': 'Şimdi tamamla',
  'hungry.ghost.special.gift.contribution': 'Katkı Sandığı',
  'hungry.ghost.special.gift.lucky': 'Şanslı Sandık',
  'hungry.ghost.special.gift.desc': 'Alınan belirlenmiş sınırlı hediyelerinizin değeri {%d} coins olduğunda Şanslı Yıldızların seçimine katılabilirsiniz ({%z}/{%m})',
  'hungry.ghost.tab.scene': 'Cadılar Bayramı Macerası',
  'hungry.ghost.tab.ranking': 'Sıralama',
  'hungry.ghost.scene.tips': 'Her yerde geçerli sınırlı hediyeler dağıtın, sahnelerin kilidini açmak ve ödüller kazanmak için karşılık gelen sayıda coinse ulaşın. Ayrıca MVP\'lerin ek ödülleri bulunmaktadır.',
  'hungry.ghost.scene.rewards.desc': 'Mevcut sahnenin kilidini açmaya katıldıktan sonra aşağıdaki ödülleri alabilirsiniz ve MVP\'nin ek ödülleri bulunmaktadır.',
  'hungry.ghost.scene.unlock.modal.title': 'Konum kilidini açmaya katıldığınız için tebrikler:',
  'hungry.ghost.scene.unlock.modal.you.can.get': 'Alabilir',
  'hungry.ghost.scene.unlock.modal.mvp.tag': 'MVP alabilir',
  'hungry.ghost.rewards.tips': 'Coins ve Elmas almayla ilgili ayrıntılar için lütfen kurallar sayfasını kontrol edin.',
  'hungry.ghost.go.look': 'Şimdi kontrol et!',
  'hungry.ghost.no.time.yet': 'Süre dolmadı',
  'hungry.ghost.next.round': 'Gelecek Round',
  'hungry.ghost.ranking.tab.send': 'Alınan Hediye Sıralaması',
  'hungry.ghost.ranking.tab.receive': 'Gönderilen Hediye Sıralaması',
  'fishing.activity.bomber': 'Bombacı',
  'fishing.activity.fishnet': 'Balık ağı',
  'fishing.activity.energy.not': 'Enerji yetersiz!',
  'fishing.activity.get.more': 'DAHA FAZLA AL',
  'fishing.activity.congrats': 'Tebrikler!',
  'fishing.activity.ok': 'TAMAM',
  'fishing.activity.catches.more': 'Yeni avlar yakaladın!',
  'fishing.activity.put.aquarium': 'Akvaryuma koy',
  'fishing.activity.catche.single': 'Yeni bir av yakaladın!',
  'fishing.activity.new': 'YENİ',
  'fishing.activity.slipped.away': 'Balık kaydı kaçtı!',
  'fishing.activity.try.again': 'TEKRAR DENE',
  'fishing.activity.step1': 'Hoş geldin! Ücretsiz balık tutmak için oltaya tıkla!',
  'fishing.activity.step3': 'Yeni bir balık türü yakalandığında akvaryum parıldayacak. Tüm balıkları toplamak bol coins ödülü kazandırabilir!',
  'fishing.activity.step5': 'Tekrar tut!',
  'fishing.activity.fishing.big': 'Şanslısın! Büyük Balıkla Tanış! Çekme kuvvetini artırmak ve hedef değere ulaşıp büyük balığı yakalamak için oltaya tıkla!',
  'fishing.activity.step8': 'Ücretsiz bir Bomba aldığınız için tebrikler! Bomba\'nın gücünü şimdi deneyin!',
  'fishing.activity.step10': 'Yinelenen balık türleri otomatik olarak Mağaza\'da ürün satın almak için kullanılabilen Kuponlarla değiştirilecektir!',
  'fishing.activity.step12': 'Yarın yine gelirsen, 1 tane daha ücretsiz Bomba alabilirsin!',
  'fishing.activity.start.fishing': 'Balık tutmaya başla',
  'fishing.activity.cap.Records': 'Kayıtlar',
  'fishing.activity.cap.Unfinished': 'Tamamlanmadı',
  'fishing.activity.cap.Date': 'Tarih',
  'fishing.activity.cap.no.record.yet': 'Henüz kayıt yok.',
  'fishing.activity.store': 'MAĞAZA',
  'fishing.activity.gallery': 'AKVARYUM',
  'fishing.activity.rank': 'Usta',
  'fishing.activity.energy': 'Enerji',
  'fishing.activity.achievement': 'KAZANÇLAR',
  'fishing.activity.records.fish': 'Balık',
  'fishing.activity.records.coupon': 'Kupon',
  'fishing.activity.records.others': 'Diğer',
  'fishing.activity.store.limit': 'Limit:',
  'fishing.activity.store.buy': 'Satın al',
  'fishing.activity.store.sold.out': 'TÜKENDİ',
  'fishing.activity.gallery.tips': 'Çok Coins kazanmak için her türlü balığı topla!',
  'fishing.activity.rank.tips': 'Günlük TOP5 Yıldız Balıkçı ekstra ödüller kazanır!',
  'fishing.activity.energy.tips': 'Günlük görevler 00:00\'da güncellenir, ödülleri zamanında toplamayı unutmayın!',
  'fishing.activity.fish.ticket.not': 'Kupon yetersiz!',
  'fishing.activity.you.got': 'Ödül kazandınız:',
  'fishing.activity.go': 'Go',
  'fishing.activity.not.time': 'Bu aşama başlamak üzere',
  'anniversary.celebration.2.collect': 'Topla',
  'anniversary.celebration.2.ok': 'TAMAM',
  'anniversary.celebration.2.waiting': 'Bekleniyor',
  'anniversary.celebration.2.special.gift.title': 'Zenginlik Hazine Kutusu',
  'anniversary.celebration.2.special.gift.to.be.drawn': 'Çekilecek',
  'anniversary.celebration.2.special.gift.to.complete': 'Şimdi tamamla',
  'anniversary.celebration.2.special.gift.contribution': 'Büyüleyici Sandık',
  'anniversary.celebration.2.special.gift.lucky': 'Şanslı Sandık',
  'anniversary.celebration.2.special.gift.desc': 'Alınan belirlenmiş sınırlı hediyelerinizin değeri {%d} coins olduğunda Şanslı Yıldızların seçimine katılabilirsiniz ({%z}/{%m})',
  'anniversary.celebration.2.tab.scene': 'Kutlama Yolculuğu',
  'anniversary.celebration.2.tab.ranking': 'Sıralama',
  'anniversary.celebration.2.scene.tips': 'Tüm platformların coins tüketimi (oyun kısmı hariç ve şanslı paket hariç), ödül almak üzere sahnelerin kilidini açmak için hedef değere ulaşır. Sınırlı hediyeler göndererek iki kat puan kazanabilirsiniz!',
  'anniversary.celebration.2.scene.rewards.desc': 'Mevcut sahnenin kilidini açmaya katıldıktan sonra aşağıdaki ödülleri alabilirsiniz ve MVP\'nin ek ödülleri bulunmaktadır.',
  'anniversary.celebration.2.scene.unlock.modal.title': 'Konum kilidini açmaya katıldığınız için tebrikler:',
  'anniversary.celebration.2.scene.unlock.modal.you.can.get': 'Alabilir',
  'anniversary.celebration.2.scene.unlock.modal.mvp.tag': 'MVP alabilir',
  'anniversary.celebration.2.rewards.tips': 'Coins ve Elmas almayla ilgili ayrıntılar için lütfen kurallar sayfasını kontrol edin.',
  'anniversary.celebration.2.go.look': 'Şimdi kontrol et!',
  'anniversary.celebration.2.no.time.yet': 'Süre dolmadı',
  'anniversary.celebration.2.next.round': 'Gelecek Round',
  'anniversary.celebration.2.ranking.tab.send': 'Alınan Hediye Sıralaması',
  'anniversary.celebration.2.ranking.tab.receive': 'Gönderilen Hediye Sıralaması',
  'crazybuilder.king.record': 'şimdiye kadar en yüksek rekor',
  'crazybuilder.mine.record': 'Mevcut Rekorum',
  'crazybuilder.reaching.floors': 'Hedef katlara ulaşana kadar paylaşılamaz',
  'crazybuilder.friends.list': 'Arkadaşlık listesi',
  'crazybuilder.friends.list.text': 'Her gün yapılan ziyaretler, arkadaşınızın kasabasına ❤️ ekleyecek',
  'crazybuilder.friends.list.visit': 'Ziyaret etmek',
  'crazybuilder.map.share.desc': 'Refah Kasabanı\'nı Paylaş! Birlikte kutlamak için arkadaşlarını davet et',
  'crazybuilder.map.share.btn': 'Şimdi paylaş',
  'crazybuilder.map.notify.title': 'Tebrikler!',
  'crazybuilder.map.notify.desc': '\"Şehriniz favoriler kazanıyor! Daha fazla ziyaretçi çekmek için inşa etmeye devam edin!',
  'crazybuilder.map.notify.btn': 'Tamam',
  'crazybuilder.map.enter': 'Kasabası',
  'crazybuilder.toast.reach': '{n} katı tamamlayarak Yapı Başarınızı paylaşabilirsiniz! Ve aşağıdaki ödülleri kazanabilirsiniz:',
  'crazybuilder.map.share.text': '#👷Çılgın İnşaatçı🚧#\nRefah Kasabaları inşa etmek için Yüksek Yetenek gereklidir! 👑💪​\n{N} Katlar ismimle - {Takma Ad} - kazındı. 🌃​\n{M} favoriler ❤️ Refah Kasabama verildi. ⭐️​\nKasabamı ziyaret ederek farkımızı görün. 😎',
  'gamecenter_ranking_txt6': 'Iyi Şanslar Listesi',
  'gamecenter_ranking_txt7': 'Oyunda 5000\'den fazla coin kazanarak sıralama tablosuna katılma hakkını kazanın. En yakın zaman içinde bu kriteri karşılayan kullanıcılar daha yüksek sıralarda yer alır.',
  'iosso_wallet_txt1': 'Daha fazla',
  'iosso_wallet_txt2': 'Katlamak',
  'chat_skill_title': 'Mutlaka Okuyun',
  'new.ranking.list.charm': 'Cazibe',
  'new.ranking.list.contribution': 'Katkı',
  'new.ranking.list.record': 'Kayıt',
  'game.list.plus.empyt.list': 'veri yok',
  'withdraw_text_0': 'Gelir',
  'withdraw_text_1': 'Bakiye',
  'withdraw_text_2': 'Çekim',
  'withdraw_text_3': 'Değişim',
  'withdraw_text_4': 'Çekim Geçmişi',
  'withdraw_text_5': 'Yetersiz Elmas Bakiyesi',
  'withdraw_text_6': 'Daha fazla elmas alın',
  'withdraw_text_7': 'Sipariş numarası:',
  'withdraw_text_8': 'Kanal:',
  'withdraw_text_9': 'Miktar:',
  'withdraw_text_10': 'Elmas:',
  'withdraw_text_11': 'Takvim:',
  'withdraw_text_12': 'İnceleme altında',
  'withdraw_text_13': 'Başarılı çekim',
  'withdraw_text_14': 'İşlem başarısız oldu',
  'withdraw_text_15': 'Başarısız işlem nedeni',
  'share_text100': 'Kopyalandı',
  'withdraw_text_16': 'Yalnızca son 3 aya ait kayıtları göster',
  'withdraw_text_21': 'Çekim Tutarı',
  'withdraw_text_22': 'Düşülen elmas',
  'withdraw_text_23': 'Ödeme yöntemi:',
  'withdraw_text_24': 'Ödeme yöntemi ekle',
  'withdraw_text_25': 'Hızlı Çekim',
  'withdraw_text_27': 'Geri bildirim sorusu',
  'withdraw_text_28': 'Müşteri Hizmetleriyle İletişime Geçin',
  'withdraw_text_30': '1. Günde en fazla bir kez çekim işlemine izin verilir',
  'withdraw_text_31': '2. Çekim işlemini başlatabilmeniz için önce gerçek kişi kimlik doğrulamasını tamamlamanız ve ödeme yöntemini bağlamanız gerekir.',
  'withdraw_text_32': '3. Platform herhangi bir ücret talep etmemektedir. Hizmet bedeli kanal tarafından kesilir. Hizmet ücretleri farklı kanallar için farklıdır. Ayrıntılar için lütfen kanalın müşteri hizmetleriyle iletişime geçin.',
  'withdraw_text_33': '4. Çekim süreci \'Çekim Kaydı\' aracılığıyla görüntülenebilir',
  'withdraw_text_34': '5. Çekim işlemi başarısız olursa elmaslar iade edilecektir',
  'withdraw_text_35': '6. Çekim başvuruları 7-14 iş günü içerisinde işleme alınacaktır (tatil günlerinde süreç uzayabilir)',
  'withdraw_text_36': 'Tamamlanmalı',
  'withdraw_text_37': '1. Gerçek kişi kimlik doğrulaması',
  'withdraw_text_38': '2. Ödeme yöntemi ekleyin',
  'program_faq_13_ios': 'İpuçları',
  'exchange_text_1': 'Değişim',
  'exchange_text_2': 'Coins Bakiyesi',
  'exchange_text_3': 'Elmas Bakiyesi',
  'exchange_text_4': 'Özel Değişim',
  'exchange_text_5': 'Değişim Kuralları',
  'exchange_text_6': 'Değişim Kuru',
  'exchange_text_7': 'Günlük Değişim Limiti',
  'exchange_text_8': 'Değişimi onaylıyor musunuz?',
  'exchange_text_9': 'Harcanan:',
  'exchange_text_10': 'Alınan:',
  'exchange_text_13': 'Yetersiz Elmas Bakiyesi',
  'withdraw_text_42': 'Desteklenen ödeme yöntemi yok',
  'withdraw_text_39': 'Bağla',
  'withdraw_text_40': 'Kontrol et',
  'exchange_text_18': 'Değişim limiti aşıldı',
  'exchange_text_14': 'Değişim başarılı',
  'ios_rechargeguide_txt3': 'Coin İadesi',
  'ios_rechargeguide_txt4': 'Topla',
  'aristocracy.vip.coin.box.sub.title': 'kadar geçerli',
  'program_faq_2': 'Program Takvimine Giriş',
  'program_faq_3': 'Eğlenceyi ve etkileşimi artırmak için bir program çizelgesi özelliği sunuyoruz. Program çizelgesi, odanın yaklaşan programlarının bir önizlemesi olarak hizmet vermektedir. İzleyiciler program çizelgesine göre oy kullanabilir ve hediyeler gönderebilir, odanın programlarına yönelik tercihlerini ve duygularını ifade edebilirler.',
  'program_faq_4': 'Program Takvimine Giriş',
  'program_faq_5': 'Oda sahibi veya yöneticisi program takvimine ayarlar menüsünden erişebilir. İzleyiciler, program canlı yayındayken odanın sağ üst köşesine tıklayarak program takvimine girebilirler.',
  'program_faq_6': 'Program Takvimi Nasıl Ayarlanır?',
  'program_faq_7': 'Program Ekle ye tıklayın ve oluşturmak istediğiniz programın adını girin.',
  'program_faq_8': 'Program takvimini oluşturup inceledikten sonra, izleyicilere görünür kılmak için \"Program Takvimini Başlat \"a tıklayın. Etkinleştirildikten sonra izleyiciler program takvimini görebilir.',
  'program_faq_9': 'Program Takvimi ile nasıl iletişim kurulur?',
  'program_faq_10': 'Odadakiler sağ üst köşeye tıklayarak program takvimine erişebilir ve program takviminin popülerliğini artırmak için \"İlgilen\" veya \"Hediye Gönder\" seçeneklerine tıklayarak favori programlarına destek verebilir.',
  'program_faq_11': 'Bir programı silebilir veya program takvimini kapatabilirsiniz.',
  'program_faq_12': 'Oda sahibi veya yöneticisi bir programın üzerinde sola kaydırır ve programı kaldırmak için \"Sil \"e tıklar. Program çizelgesi 7 gün sonra otomatik olarak kapanacaktır, ancak sahibi veya yöneticisi manuel olarak da kapatabilir. Bir programın silinmesi veya program takviminin kapatılması, program popülerlik verilerini temizleyecektir.',
  'program_faq_13': 'İpuçları',
  'program_faq_14': '1.Program takvimi en fazla 15 programın eklenmesine izin verir.',
  'program_faq_15': '2.İncelemede başarısız olan program takvimi açılamaz.',
  'program_faq_16': '3. Program takvimi açıldıktan 7 gün sonra otomatik olarak kapatılır.',
  'program_faq_part1': 'Bölüm 1',
  'program_faq_part2': 'Bölüm 2',
  'program_faq_part3': 'Bölüm 3',
  'program_faq_part4': 'Bölüm 4',
  'withdraw_text_45': 'Gönderim zamanı',
  'withdraw_text_46': '5 iş günü içerisinde hesabınıza ulaşacaktır. Detaylar, çekim kaydından kontrol edilebilir.',
  'withdraw_text_47': 'Tamamlandı',
  'withdraw_text_48': 'Ödeme yöntemi',
  'payment_bind_1': 'Hesap',
  'exchange_text_16': 'Değişim başarısız oldu',
  'withdraw_text_59': 'Güncelleme',
  'payment_bind_28': 'Account Type',
  'payment_bind_29': 'Hesap Türü',
  'payment_bind_30': 'Account Number',
  'payment_bind_32': 'Phone number',
  'payment_bind_33': 'Must be 12 digits starting with 2541 or 2547',
  'payment_bind_34': 'Banka Seç',
  'payment_bind_35': 'Banka Ara',
  'payment_bind_36': 'Hesap adı',
  'payment_bind_37': 'Yalnızca rakam olmalı, boşluk veya özel karakter içermemelidir',
  'payment_bind_38': '9 veya 10 haneli olmalı ve 233 ile başlamamalıdır',
  'payment_bind_39': '@ içeren, en az 2 karakterlik uzantılı ve boşluksuz geçerli bir e-posta olmalıdır',
  'payment_bind_40': 'Yalnızca 10 haneli rakam olmalı, boşluk veya özel karakter içermemelidir',
  'payment_bind_41': "Yalnızca İngilizce harf, rakam, boşluk ve kesme işareti (') kullanılabilir, İngilizce harfle başlamalıdır",
  'family_text_116': 'Tavsiye et',
  'family_text_117': 'Sıralama',
  'family_text_97': 'Bugün',
  'family_text_98': 'Aylık',
  'family_text_108': 'Dün',
  'family_text_69': 'Geçen ay',
  'family_text_95': 'Popüler',
  'family_text_96': 'Yeni',
  'family_text_68': 'Bu ay',
  'family_toast_03': 'Katıl',
  'family_toast_04': 'İnceleme altında',
  'family_toast_05': 'Başarıyla aileye katıldın.',
  'family_toast_02': 'Başvurunuz gönderildi, lütfen onaylanmasını bekleyin.',
  'family_toast_08': 'Aile Oluştur',
  'family_enter': 'Aile',
  'specialoffer_9': 'Özel Teklif',
  'specialoffer_10': '{%s} Madeni Para',
  'rewardboost_24': 'Mevcut özel teklif yok.',
  'ramadan_daily_pool': 'Günlük Havuz',
  'ramadan_grand_pool': 'Büyük Havuz',
  'ramadan_sharing_countdown': 'Paylaşım Geri Sayımı:',
  'ramadan_today_coin_get': 'Dünkü ödül havuzu paylaşıldı! Şunları aldınız:',
  'ramadan_top3_reward': 'Günlük TOP3\'e girenler ödülleri kazanır.',
  'ramadan_up_need': 'YUKARI İHTİYAÇ{N}{Pointicon}',
  'ramadan_sign_days': '{N} gün boyunca oturum açın',
  'spring.cp.cruise.my.count': 'Benim Sayım',
  'Noble_Change_5_METR': 'Örnek: Şu anda bir Vikont iseniz (499950 coins/ay), 13 gününüz kaldı ve bugün Kont (999950 coins/ay) satın aldıysanız, ödeme yapıldıktan sonra Kont\'un geçerlilik süresi 13 * (499950/999950) olacaktır. + 30 = 6,5 aşağı yuvarlanmış + 30 = 36 gün.',
  'Noble_Change_5_TR': 'Örnek: Şu anda bir Vikont iseniz (499950 coins/ay), 13 gününüz kaldı ve bugün Kont (999950 coins/ay) satın aldıysanız, ödeme yapıldıktan sonra Kont\'un geçerlilik süresi 13 * (499950/999950) olacaktır. + 30 = 6,5 aşağı yuvarlanmış + 30 = 36 gün.',
  'Noble_Change_5_ME': 'Örnek: Şu anda bir Vikont iseniz (999900 coins/ay), 13 gününüz kaldı ve bugün Kont (1999900 coins/ay) satın aldıysanız, ödeme yapıldıktan sonra Kont\'un geçerlilik süresi 13 * (999900/1999900) olacaktır. + 30 = 6,5 aşağı yuvarlanmış + 30 = 36 gün.',
  'lasser.bairam.rank.no.self': 'Üzgünüz, şu anda listede değilsiniz.',
  'lucky.packet.7_TR': '3. Kişi başına miktar (altın miktarı/kişi sayısı) en az 5 altın olmalıdır.',
  'lucky.packet.7_ME': '3. Kişi başına miktar (altın miktarı/kişi sayısı) en az 10 altın olmalıdır.',
  'lucky.packet.8_TR': 'Paket miktarı 50000 coins\'ten fazla olduğunda ve katılımcı sayısı 10\'den fazla olduğunda, bu bir uçan bildirimi tetikleyecek ve oda listesinde özel bir simge görüntülenecektir.',
  'lucky.packet.8_ME': 'Paket miktarı 100000 coins\'ten fazla olduğunda ve katılımcı sayısı 10\'den fazla olduğunda, bu bir uçan bildirimi tetikleyecek ve oda listesinde özel bir simge görüntülenecektir.',
  'detail_recharge': 'Yükleme yap',
  'detail_chat': 'Sohbet',
  'detail_gift': 'Hediye',
  'detail_game': 'Oyunlar',
  'detail_rewards': 'Ödüller',
  'detail_other': 'Diğer',
  'detail_return': 'Geri ver',
  'cp_ranking_total': 'Genel',
  'cp_ranking_longest': 'En Uzun Süreli CP',
  'cp_ranking_title': 'CP Sıralaması',
  'anchor_center_income': 'Gelir',
  'anchor_center_balance': 'Bakiye',
  'anchor_center_withdraw': 'Para Çekme',
  'anchor_center_exchange': 'Değişim',
  'anchor_center_anchor_benefits': 'Yayıncı Avantajları',
  'anchor_center_the_higher_your_level_the_more_often_you_are_sho': 'Seviyeniz ne kadar yüksekse, başkalarına o kadar çok gösterilir ve o kadar çok mesaj alırsınız.',
  'anchor_center_active_time_value': 'Aktif Süre: {0}',
  'anchor_center_1_point_10_mins_active': 'Aktif {0} dakika +1 puan',
  'anchor_center_voice_room_active_time_value': 'Mikrofonda Geçirilen Süre: {0}',
  'anchor_center_until_level': 'Mikrofonda Geçirilen {0} dakika = 1 puan',
  'anchor_center_number_of_replied_users_value': 'Yanıtlanan Kullanıcı Sayısı: {0}',
  'anchor_center_1_point_reply_5_users': '{0} kullanıcıya yanıt verildi +1 puan',
  'anchor_center_exchange_2': 'Değişim',
  'anchor_center_1_point_per_1000_coins': 'Her {0} Para +1 puan',
  'anchor_center_anchor_level_guide': 'Yayıncı Seviyesi Yönergeleri',
  'anchor_center_1_anchor_levels_are_calculated_every_two_weeks': '1. Yayıncı seviyesi her {%s4} haftada bir hesaplanır. 2. Ödüller, gerekli seviyeye ulaşıldığında hemen verilir. 3. Gümüş: {%s1} puan\\nAltın: {%s2} puan\\nElmas: {%s3} puan\\n4. Çevrimiçi süre ve sesli sohbet aktivite süresi ayrı ayrı hesaplanır.',
  'anchor_center_1_anchor_levels_are_calculated_every_two_weeks_2': '1. Yayıncı seviyesi her {%s4} haftada bir hesaplanır. 2. Ödüller, gerekli seviyeye ulaşıldığında hemen verilir. 3. Gümüş: {%s1} puan\\nAltın: {%s2} puan\\nElmas: {%s3} puan\\n4. Çevrimiçi süre ve sesli sohbet aktivite süresi ayrı ayrı hesaplanır.',
  'anchor_center_level1': 'Gümüş',
  'anchor_center_level2': 'Altın',
  'anchor_center_level3': 'Elmas',
  'anchor_center_level': 'Sunucu Seviyesi',
};

export default TR;
